webpackJsonp([22],{

/***/ "+HRU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg","fill":"#fff"}},[_c('path',{attrs:{"d":"M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"}}),_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+Hfi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2805488a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_edm_vue__ = __webpack_require__("gifX");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2805488a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_edm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+bkg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0af8fe5e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_save_vue__ = __webpack_require__("zxCS");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0af8fe5e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_save_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+nMQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 60.06 60.06","width":"512","height":"512","fill":"#FFF"}},[_c('path',{attrs:{"d":"M60.05 11.2v-.08c.02-.07 0-.14 0-.22v-.06a1 1 0 0 0-.1-.28l-.03-.05v-.01l-.03-.04a.99.99 0 0 0-.22-.23l-.06-.03a.96.96 0 0 0-.24-.12l-.1-.02a.97.97 0 0 0-.35-.02l-.08.01-58.04 12a1 1 0 0 0-.27 1.86l16.64 8.77 2.91 16.19v.04a.94.94 0 0 0 .02.35c.02.1.06.18.11.27l.02.05.01.01.05.06.15.15.03.03.04.02.2.1.07.03a1 1 0 0 0 .28.04h.07a1 1 0 0 0 .71-.31l11.08-7.39 11.6 7.54a1 1 0 0 0 1.48-.5l14-37.98a.92.92 0 0 0 .03-.1v-.05l.02-.03zm-11.59 6.38L24.47 35.22l-.1.1-.04.03a1 1 0 0 0-.06.07l-.05.08-.09.19-.02.03v.01l-2.75 8.94-2.18-12.1 29.28-15zM22.91 46.59l2.72-9 4.25 2.76 1.21.79-4.12 2.75-4.06 2.7zm29.13-33.1L18.07 30.9 3.93 23.45l48.11-9.94zM44.56 47.5l-15.4-10-2.34-1.53L56.97 13.8 44.56 47.5z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/7YS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("zwoO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__("Pf15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__model__ = __webpack_require__("FfD9");








var User = function (_Model) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(User, _Model);

  function User(params) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, User);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (User.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(User)).call(this));

    _this.id = params.id;
    _this.name = params.name;
    _this.email = params.email;
    _this.avatar_url = params.avatar_url;
    _this.token = params.token;
    _this.permission = params.permission;
    return _this;
  }

  //
  // Permissions
  //

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(User, [{
    key: 'permissions',


    /**
     * Get permission code
     * @param  {Number} permissions
     * @return {Array}
     */
    get: function get() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(User.permissions).filter(function (bit) {
        return (_this2.permission & bit) !== 0;
      });
    }
  }, {
    key: 'canCreateProject',
    get: function get() {
      return this.permissions.includes('1');
    }
  }, {
    key: 'canEditProject',
    get: function get() {
      return this.permissions.includes('2');
    }
  }, {
    key: 'canPreviewProject',
    get: function get() {
      return this.permissions.includes('4');
    }
  }, {
    key: 'canDeleteProject',
    get: function get() {
      return this.permissions.includes('8');
    }
  }, {
    key: 'canPublishProject',
    get: function get() {
      return this.permissions.includes('16');
    }
  }, {
    key: 'canReviewProject',
    get: function get() {
      return this.permissions.includes('32');
    }

    //
    // Auth
    //

  }], [{
    key: 'loginWithGoogle',
    value: function loginWithGoogle(code, redirectURI) {
      return this.http.post('auth/google/callback', { code: code, redirect_uri: redirectURI }).then(function (res) {
        return res.data;
      });
    }
  }, {
    key: 'loginWithToken',
    value: function loginWithToken(token) {
      return this.http.post('auth', { token: token }).then(function (res) {
        return res.data;
      });
    }
  }, {
    key: 'permissions',
    get: function get() {
      return {
        1: '建立專案',
        2: '編輯專案',
        4: '預覽專案',
        8: '刪除專案',
        16: '發佈', // publish
        32: '發佈核准' // review
      };
    }
  }]);

  return User;
}(__WEBPACK_IMPORTED_MODULE_6__model__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (User);

/***/ }),

/***/ "/I6o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31174c2e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_olist_vue__ = __webpack_require__("0i3K");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31174c2e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_olist_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/KK3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e318904_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_italic_vue__ = __webpack_require__("GoAe");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e318904_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_italic_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/Zsp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b53ca22_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sync_vue__ = __webpack_require__("+HRU");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b53ca22_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sync_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/cD4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__add__ = __webpack_require__("7obO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arrow_down__ = __webpack_require__("hCpS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__align_left__ = __webpack_require__("0s2b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__align_right__ = __webpack_require__("7jki");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__align_justify__ = __webpack_require__("z5t4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__align_center__ = __webpack_require__("DDuV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__font_size__ = __webpack_require__("NzTo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__arrow_up__ = __webpack_require__("rFay");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__back__ = __webpack_require__("y1wj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__back_white__ = __webpack_require__("B1iL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__bold__ = __webpack_require__("xatV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__bug__ = __webpack_require__("DHiq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__chrome__ = __webpack_require__("8Bgx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__close__ = __webpack_require__("Lut1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__cloud_off__ = __webpack_require__("9g4A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__code__ = __webpack_require__("6sYM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__delete__ = __webpack_require__("ozkX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__desktop__ = __webpack_require__("YjWl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__dns__ = __webpack_require__("6XF9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__download__ = __webpack_require__("s7Xz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__edit__ = __webpack_require__("rHal");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__edm__ = __webpack_require__("+Hfi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__error_outline__ = __webpack_require__("Ktwz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__filter__ = __webpack_require__("8OP4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__format_clear__ = __webpack_require__("6uu2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__fullscreen__ = __webpack_require__("TbTy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__fullscreen_exit__ = __webpack_require__("f56N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__history__ = __webpack_require__("9+KY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__image__ = __webpack_require__("3gvk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__images__ = __webpack_require__("YWmX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__indent__ = __webpack_require__("6RVV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__info__ = __webpack_require__("XtEy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__italic__ = __webpack_require__("/KK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__layers__ = __webpack_require__("0rI+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__link__ = __webpack_require__("3NwR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__logo__ = __webpack_require__("Oqj+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__mobile__ = __webpack_require__("hZay");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__new_window__ = __webpack_require__("vUdT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__olist__ = __webpack_require__("/I6o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__outdent__ = __webpack_require__("kofh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__palette__ = __webpack_require__("W/Fe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__preview__ = __webpack_require__("TNU0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__publish__ = __webpack_require__("rQYt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__remove__ = __webpack_require__("Zv3s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__redo__ = __webpack_require__("zW1o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__undo__ = __webpack_require__("7/VR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__save__ = __webpack_require__("+bkg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__search__ = __webpack_require__("LBso");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__setting__ = __webpack_require__("cKMs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__sort__ = __webpack_require__("ImbY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__stop__ = __webpack_require__("4db/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__sync__ = __webpack_require__("/Zsp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__text__ = __webpack_require__("PxI5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__toggle_sidebar_left__ = __webpack_require__("APCV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__toggle_sidebar_right__ = __webpack_require__("NLfJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__ulist__ = __webpack_require__("ATKp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__underline__ = __webpack_require__("loVc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__video__ = __webpack_require__("lWON");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__zoomin__ = __webpack_require__("57g8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__zoomout__ = __webpack_require__("lThe");





























































/* harmony default export */ __webpack_exports__["a"] = ({
  'arrow-up': __WEBPACK_IMPORTED_MODULE_7__arrow_up__["a" /* default */],
  'arrow-down': __WEBPACK_IMPORTED_MODULE_1__arrow_down__["a" /* default */],
  'align-left': __WEBPACK_IMPORTED_MODULE_2__align_left__["a" /* default */],
  'align-right': __WEBPACK_IMPORTED_MODULE_3__align_right__["a" /* default */],
  'align-justify': __WEBPACK_IMPORTED_MODULE_4__align_justify__["a" /* default */],
  'align-center': __WEBPACK_IMPORTED_MODULE_5__align_center__["a" /* default */],
  'font-size': __WEBPACK_IMPORTED_MODULE_6__font_size__["a" /* default */],
  'back': __WEBPACK_IMPORTED_MODULE_8__back__["a" /* default */],
  'back-white': __WEBPACK_IMPORTED_MODULE_9__back_white__["a" /* default */],
  'cloud-off': __WEBPACK_IMPORTED_MODULE_14__cloud_off__["a" /* default */],
  'error-outline': __WEBPACK_IMPORTED_MODULE_22__error_outline__["a" /* default */],
  'format-clear': __WEBPACK_IMPORTED_MODULE_24__format_clear__["a" /* default */],
  'fullscreen-exit': __WEBPACK_IMPORTED_MODULE_26__fullscreen_exit__["a" /* default */],
  'new-window': __WEBPACK_IMPORTED_MODULE_37__new_window__["a" /* default */],
  'toggle-sidebar-left': __WEBPACK_IMPORTED_MODULE_53__toggle_sidebar_left__["a" /* default */],
  'toggle-sidebar-right': __WEBPACK_IMPORTED_MODULE_54__toggle_sidebar_right__["a" /* default */],
  add: __WEBPACK_IMPORTED_MODULE_0__add__["a" /* default */],
  redo: __WEBPACK_IMPORTED_MODULE_44__redo__["a" /* default */],
  undo: __WEBPACK_IMPORTED_MODULE_45__undo__["a" /* default */],
  bold: __WEBPACK_IMPORTED_MODULE_10__bold__["a" /* default */],
  bug: __WEBPACK_IMPORTED_MODULE_11__bug__["a" /* default */],
  chrome: __WEBPACK_IMPORTED_MODULE_12__chrome__["a" /* default */],
  close: __WEBPACK_IMPORTED_MODULE_13__close__["a" /* default */],
  code: __WEBPACK_IMPORTED_MODULE_15__code__["a" /* default */],
  delete: __WEBPACK_IMPORTED_MODULE_16__delete__["a" /* default */],
  desktop: __WEBPACK_IMPORTED_MODULE_17__desktop__["a" /* default */],
  dns: __WEBPACK_IMPORTED_MODULE_18__dns__["a" /* default */],
  download: __WEBPACK_IMPORTED_MODULE_19__download__["a" /* default */],
  edit: __WEBPACK_IMPORTED_MODULE_20__edit__["a" /* default */],
  edm: __WEBPACK_IMPORTED_MODULE_21__edm__["a" /* default */],
  filter: __WEBPACK_IMPORTED_MODULE_23__filter__["a" /* default */],
  fullscreen: __WEBPACK_IMPORTED_MODULE_25__fullscreen__["a" /* default */],
  history: __WEBPACK_IMPORTED_MODULE_27__history__["a" /* default */],
  image: __WEBPACK_IMPORTED_MODULE_28__image__["a" /* default */],
  images: __WEBPACK_IMPORTED_MODULE_29__images__["a" /* default */],
  indent: __WEBPACK_IMPORTED_MODULE_30__indent__["a" /* default */],
  info: __WEBPACK_IMPORTED_MODULE_31__info__["a" /* default */],
  italic: __WEBPACK_IMPORTED_MODULE_32__italic__["a" /* default */],
  layers: __WEBPACK_IMPORTED_MODULE_33__layers__["a" /* default */],
  link: __WEBPACK_IMPORTED_MODULE_34__link__["a" /* default */],
  logo: __WEBPACK_IMPORTED_MODULE_35__logo__["a" /* default */],
  mobile: __WEBPACK_IMPORTED_MODULE_36__mobile__["a" /* default */],
  olist: __WEBPACK_IMPORTED_MODULE_38__olist__["a" /* default */],
  outdent: __WEBPACK_IMPORTED_MODULE_39__outdent__["a" /* default */],
  palette: __WEBPACK_IMPORTED_MODULE_40__palette__["a" /* default */],
  preview: __WEBPACK_IMPORTED_MODULE_41__preview__["a" /* default */],
  publish: __WEBPACK_IMPORTED_MODULE_42__publish__["a" /* default */],
  remove: __WEBPACK_IMPORTED_MODULE_43__remove__["a" /* default */],
  save: __WEBPACK_IMPORTED_MODULE_46__save__["a" /* default */],
  search: __WEBPACK_IMPORTED_MODULE_47__search__["a" /* default */],
  setting: __WEBPACK_IMPORTED_MODULE_48__setting__["a" /* default */],
  sort: __WEBPACK_IMPORTED_MODULE_49__sort__["a" /* default */],
  stop: __WEBPACK_IMPORTED_MODULE_50__stop__["a" /* default */],
  sync: __WEBPACK_IMPORTED_MODULE_51__sync__["a" /* default */],
  text: __WEBPACK_IMPORTED_MODULE_52__text__["a" /* default */],
  ulist: __WEBPACK_IMPORTED_MODULE_55__ulist__["a" /* default */],
  underline: __WEBPACK_IMPORTED_MODULE_56__underline__["a" /* default */],
  video: __WEBPACK_IMPORTED_MODULE_57__video__["a" /* default */],
  zoomin: __WEBPACK_IMPORTED_MODULE_58__zoomin__["a" /* default */],
  zoomout: __WEBPACK_IMPORTED_MODULE_59__zoomout__["a" /* default */]
});

/***/ }),

/***/ "/fE0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("zwoO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__("Pf15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__block__ = __webpack_require__("1Y7b");







var YoutubeBlock = function (_Block) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(YoutubeBlock, _Block);

  function YoutubeBlock(block) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, YoutubeBlock);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (YoutubeBlock.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(YoutubeBlock)).call(this, block));

    _this.type = 'youtube';
    _this.alias = 'Youtube - ' + _this.uid;
    _this.src = '';
    _this.youtubeId = '';
    _this.image = {
      url: '',
      size: 0,
      width: 0,
      height: 0,
      title: ''
    };
    _this.linkable = {
      type: 'href',
      href: '',
      title: ''
    };
    _this.style = {
      paddingTop: 0,
      paddingRight: 0,
      paddingBottom: 0,
      paddingLeft: 0
    };
    _this.bgImage = {
      url: '',
      size: 0,
      width: 0,
      height: 0,
      title: ''
    };
    if (block) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["merge"])(_this, block);
    }
    return _this;
  }

  return YoutubeBlock;
}(__WEBPACK_IMPORTED_MODULE_5__block__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (YoutubeBlock);

/***/ }),

/***/ "0i3K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"height":"24","width":"24","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M2 17h2v.5H3v1h1v.5H2v1h3v-4H2v1zm1-9h1V4H2v1h1v3zm-1 3h1.8L2 13.1v.9h3v-1H3.2L5 10.9V10H2v1zm5-6v2h14V5H7zm0 14h14v-2H7v2zm0-6h14v-2H7v2z"}}),_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0rI+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65074b16_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layers_vue__ = __webpack_require__("qdue");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65074b16_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0s2b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b7a5d55_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_align_left_vue__ = __webpack_require__("rwyL");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b7a5d55_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_align_left_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1+qV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__iframe__ = __webpack_require__("Yych");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__image__ = __webpack_require__("qlif");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__image_map__ = __webpack_require__("2f36");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images__ = __webpack_require__("sVQ6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__product__ = __webpack_require__("y6dV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__sticky_menu__ = __webpack_require__("nIXq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__text__ = __webpack_require__("Uf/J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__youtube__ = __webpack_require__("/fE0");











var BlockFactory = function () {
  function BlockFactory() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, BlockFactory);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(BlockFactory, null, [{
    key: 'create',
    value: function create(type, block) {
      var Klass = this.list[type];
      var instance = new Klass(block);
      return instance;
    }
  }, {
    key: 'list',
    get: function get() {
      return {
        'iframe': __WEBPACK_IMPORTED_MODULE_2__iframe__["a" /* default */],
        'image': __WEBPACK_IMPORTED_MODULE_3__image__["a" /* default */],
        'image_map': __WEBPACK_IMPORTED_MODULE_4__image_map__["a" /* default */],
        'images': __WEBPACK_IMPORTED_MODULE_5__images__["a" /* default */],
        'product': __WEBPACK_IMPORTED_MODULE_6__product__["a" /* default */],
        'sticky_menu': __WEBPACK_IMPORTED_MODULE_7__sticky_menu__["a" /* default */],
        'text': __WEBPACK_IMPORTED_MODULE_8__text__["a" /* default */],
        'youtube': __WEBPACK_IMPORTED_MODULE_9__youtube__["a" /* default */]
      };
    }
  }]);

  return BlockFactory;
}();

/* harmony default export */ __webpack_exports__["a"] = (BlockFactory);

/***/ }),

/***/ "1Aps":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1Y7b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("zwoO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__("Pf15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model__ = __webpack_require__("FfD9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shortid__ = __webpack_require__("Z8es");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shortid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_shortid__);







var Block = function (_Model) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Block, _Model);

  function Block(block) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Block);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Block.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Block)).call(this));

    _this.uid = block && block.uid || __WEBPACK_IMPORTED_MODULE_5_shortid___default.a.generate();
    return _this;
  }

  return Block;
}(__WEBPACK_IMPORTED_MODULE_4__model__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Block);

/***/ }),

/***/ "27yv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"gray-lighter":"#f9fafb","gray-light":"#f3f5f7","gray-base":"#dee3e7","gray-dark":"#c3cdd5","gray-darker":"#313b45","ink-lightest":"#929fab","ink-lighter":"#607080","ink-light":"#444f5a","ink-base":"#212b35","blue-lighter":"#ebf5fa","blue-light":"#afe1f8","blue-base":"#437adf","blue-dark":"#005085","blue-darker":"#001529","green-lighter":"#e3f1df","green-light":"#bbe5b3","green-base":"#51b93c","green-dark":"#107f42","green-darker":"#17362f","yellow-lighter":"#fcf2cf","yellow-light":"#ffe98a","yellow-base":"#f0c400","yellow-dark":"#9a6d19","yellow-darker":"#573b00","red-lighter":"#fbeae5","red-light":"#feb09a","red-base":"#ed6145","red-dark":"#c00710","red-darker":"#320101","purple-lighter":"#f7f2fd","purple-light":"#e3d1ff","purple-base":"#9b68de","purple-dark":"#50248f","purple-darker":"#230052","orange-lighter":"#fcead9","orange-light":"#ffc48a","orange-base":"#f49343","orange-dark":"#c05716","orange-darker":"#491504","bar":"uO5BX_0","success":"_3TfO1_0","failed":"_38q49_0"};

/***/ }),

/***/ "2AJj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"height":"24","width":"24","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}}),_c('path',{attrs:{"d":"M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2ATC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}}),_c('path',{attrs:{"d":"M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62A7.95 7.95 0 0 1 20.1 16l2.37-.78A10.51 10.51 0 0 0 12.5 8z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2f36":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("zwoO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__("Pf15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__block__ = __webpack_require__("1Y7b");







var ImageMapBlock = function (_Block) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(ImageMapBlock, _Block);

  function ImageMapBlock(block) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ImageMapBlock);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ImageMapBlock.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ImageMapBlock)).call(this, block));

    _this.type = 'image_map';
    _this.alias = '\u5716\u7247\u5730\u5716 - ' + _this.uid;
    _this.mobile = {
      image: {
        url: '',
        size: 0,
        width: 0,
        height: 0,
        title: ''
      },
      areas: [],
      linkables: []
    };
    _this.desktop = {
      image: {
        url: '',
        size: 0,
        width: 0,
        height: 0,
        title: ''
      },
      areas: [],
      linkables: []
    };

    if (block) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["merge"])(_this, block);
    }
    return _this;
  }

  return ImageMapBlock;
}(__WEBPACK_IMPORTED_MODULE_5__block__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (ImageMapBlock);

/***/ }),

/***/ "2hfY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export inputDate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


function pad(string) {
  return ('0' + string).slice(-2);
}

/* harmony default export */ __webpack_exports__["a"] = (function (timestamp) {
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(timestamp) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["isDate"])(timestamp)) {
    return timestamp;
  }

  var date = new Date(timestamp);

  if (!date.valueOf()) {
    throw new Error('invalid date');
  }

  var yyyy = date.getFullYear();
  var mm = pad(date.getMonth() + 1);
  var dd = pad(date.getDate());
  var hh = pad(date.getHours());
  var m = pad(date.getMinutes());
  var s = pad(date.getSeconds());

  return yyyy + '/' + mm + '/' + dd + ' ' + hh + ':' + m + ':' + s;
});

function inputDate(timestamp) {
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(timestamp) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["isDate"])(timestamp)) {
    return timestamp;
  }

  var date = new Date(timestamp);

  var yyyy = date.getFullYear();
  var mm = pad(date.getMonth() + 1);
  var dd = pad(date.getDate());

  return yyyy + '-' + mm + '-' + dd;
}

/***/ }),

/***/ "2mV7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__account__ = __webpack_require__("Dxc6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__alert__ = __webpack_require__("zGyS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__editor__ = __webpack_require__("HJ/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__progress__ = __webpack_require__("TYWd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__projects__ = __webpack_require__("ETak");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__galleries__ = __webpack_require__("fV6m");







/* harmony default export */ __webpack_exports__["a"] = ({
  account: __WEBPACK_IMPORTED_MODULE_0__account__["a" /* default */],
  alert: __WEBPACK_IMPORTED_MODULE_1__alert__["a" /* default */],
  editor: __WEBPACK_IMPORTED_MODULE_2__editor__["a" /* default */],
  galleries: __WEBPACK_IMPORTED_MODULE_5__galleries__["a" /* default */],
  progress: __WEBPACK_IMPORTED_MODULE_3__progress__["a" /* default */],
  projects: __WEBPACK_IMPORTED_MODULE_4__projects__["a" /* default */]
});

/***/ }),

/***/ "3NwR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_858a2e64_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_link_vue__ = __webpack_require__("clsu");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_858a2e64_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_link_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3gvk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_193b8ab7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_image_vue__ = __webpack_require__("npSS");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_193b8ab7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_image_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3viG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"15.5 15.5 224.5 224.5"}},[_c('defs',[_c('radialGradient',{attrs:{"cy":"0","cx":".5","id":"c"}},[_c('stop',{attrs:{"stop-color":"#f06b59"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#df2227"}})],1),_c('radialGradient',{attrs:{"r":".76","cy":".3","cx":".65","id":"d"}},[_c('stop',{attrs:{"offset":".65","stop-color":"#4cb749"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#388b41"}})],1),_c('radialGradient',{attrs:{"r":".8","cy":".25","cx":".36","id":"e"}},[_c('stop',{attrs:{"offset":".6","stop-color":"#FCD209"}}),_c('stop',{attrs:{"offset":".7","stop-color":"#f7c616"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#bc821e"}})],1),_c('radialGradient',{attrs:{"r":"1","cy":"0","cx":".5","spreadMethod":"pad","id":"a"}},[_c('stop',{attrs:{"offset":".1","stop-color":"#7FB3DF"}}),_c('stop',{attrs:{"offset":".9","stop-color":"#0F5B94"}})],1),_c('radialGradient',{attrs:{"id":"b","r":"1","cy":"0","cx":".5"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#F6F0EE"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#ddd"}})],1)],1),_c('path',{attrs:{"d":"M198 148a70 70 0 0 0-140 0h20a50 50 0 0 1 100 0","fill-opacity":".1"}}),_c('circle',{attrs:{"r":"45","cx":"127.5","cy":"127.6","fill":"url(#a)","stroke":"url(#b)","stroke-width":"9"}}),_c('path',{attrs:{"d":"M228 78A112 112 0 0 0 35 65l45 78a50 50 0 0 1 47-65","fill":"url(#c)"}}),_c('path',{attrs:{"d":"M35 65a112 112 0 0 0 84 174l47-80a50 50 0 0 1-86-16","fill":"url(#d)"}}),_c('path',{attrs:{"d":"M119 239A112 112 0 0 0 228 78H127a50 50 0 0 1 39 81","fill":"url(#e)"}}),_c('path',{attrs:{"d":"M35 65l45 78a50 50 0 0 1 2-34L37 62","opacity":".07"}}),_c('path',{attrs:{"d":"M119 239l47-80a50 50 0 0 1-29 17l-20 63M228 78H127a50 50 0 0 1 39 19l64-16","opacity":".05"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3vsC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("zwoO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__("Pf15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__model__ = __webpack_require__("FfD9");







var Gallery = function (_Model) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Gallery, _Model);

  function Gallery(gallery) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Gallery);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Gallery.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Gallery)).call(this));

    _this.id = gallery.id;
    _this.name = gallery.name;
    _this.projects_list = gallery.projects_list;
    _this.updated_at = gallery.updated_at;
    _this.created_at = gallery.created_at;
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Gallery, null, [{
    key: 'all',
    value: function all() {
      return this.api.get('galleries').then(function (res) {
        return res.data;
      });
    }
  }]);

  return Gallery;
}(__WEBPACK_IMPORTED_MODULE_5__model__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Gallery);

/***/ }),

/***/ "4db/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_477a0654_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_stop_vue__ = __webpack_require__("f6E1");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_477a0654_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_stop_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4lHW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_progress_bar_vue__ = __webpack_require__("4yAO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fdf2b980_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_progress_bar_vue__ = __webpack_require__("rFOT");
function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__("27yv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_progress_bar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fdf2b980_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_progress_bar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4yAO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'progress-bar',

  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapState */])('progress', ['percent', 'canSuccess', 'show'])
});

/***/ }),

/***/ "57g8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_658d930c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_zoomin_vue__ = __webpack_require__("ICW2");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_658d930c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_zoomin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5F+9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M3 21h18v-2H3v2zm0-4h18v-2H3v2zm0-4h18v-2H3v2zm0-4h18V7H3v2zm0-6v2h18V3H3z"}}),_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5kFl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}}),_c('path',{attrs:{"d":"M21 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7l-2 3v1h8v-1l-2-3h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 12H3V4h18v10z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6KYS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}}),_c('path',{attrs:{"d":"M20 8h-2.81a5.98 5.98 0 0 0-1.82-1.96L17 4.41 15.59 3l-2.17 2.17a6.07 6.07 0 0 0-2.83 0L8.41 3 7 4.41l1.62 1.63A6.06 6.06 0 0 0 6.81 8H4v2h2.09c-.05.33-.09.66-.09 1v1H4v2h2v1c0 .34.04.67.09 1H4v2h2.81a6 6 0 0 0 10.38 0H20v-2h-2.09c.05-.33.09-.66.09-1v-1h2v-2h-2v-1c0-.34-.04-.67-.09-1H20V8zm-6 8h-4v-2h4v2zm0-4h-4v-2h4v2z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6RVV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f932bd00_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_indent_vue__ = __webpack_require__("qGLw");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f932bd00_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_indent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6XF9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04841085_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dns_vue__ = __webpack_require__("k2nX");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04841085_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dns_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6sYM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4250b541_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_code_vue__ = __webpack_require__("vDhE");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4250b541_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_code_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6uu2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02943b59_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_format_clear_vue__ = __webpack_require__("vaBA");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02943b59_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_format_clear_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7/VR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bcc8cb8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_undo_vue__ = __webpack_require__("2ATC");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bcc8cb8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_undo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7jki":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bdd33184_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_align_right_vue__ = __webpack_require__("fvHD");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bdd33184_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_align_right_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7obO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53ed87fd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_add_vue__ = __webpack_require__("g+IU");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53ed87fd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_add_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8Bgx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cd9ec4e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_chrome_vue__ = __webpack_require__("3viG");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cd9ec4e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_chrome_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8EoV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"64","xmlns":"http://www.w3.org/2000/svg","height":"64","viewBox":"0 0 64 64","fill":"#1D1D1B"}},[_c('path',{attrs:{"d":"M28.94 31.786L.614 60.114c-.787.787-.787 2.062 0 2.85.393.393.91.59 1.424.59.516 0 1.03-.197 1.424-.59L32.003 34.42l28.54 28.54c.395.395.91.59 1.425.59s1.03-.195 1.424-.59c.788-.786.788-2.06 0-2.848L35.065 31.786 63.41 3.438c.787-.787.787-2.062 0-2.85-.787-.785-2.062-.785-2.848 0L32.002 29.15 3.443.59C2.653-.196 1.38-.196.59.59c-.786.787-.786 2.062 0 2.85l28.35 28.346z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8OP4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a43364c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_filter_vue__ = __webpack_require__("Hlcb");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a43364c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_filter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9+KY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea6aff20_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_history_vue__ = __webpack_require__("OHCg");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea6aff20_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_history_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9g4A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a5122c1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cloud_off_vue__ = __webpack_require__("K7D5");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a5122c1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cloud_off_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "APCV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0757eb71_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_toggle_sidebar_left_vue__ = __webpack_require__("Wk86");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0757eb71_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_toggle_sidebar_left_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ATKp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_610ef3ef_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ulist_vue__ = __webpack_require__("TZFD");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_610ef3ef_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ulist_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AaU6":
/***/ (function(module, exports) {



/***/ }),

/***/ "Awda":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bus__ = __webpack_require__("rczV");
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Tooltip',

  data: function data() {
    return {
      visible: false,
      value: '',
      top: '',
      left: '',
      offset: 5
    };
  },


  computed: {
    shown: function shown() {
      return this.visible && this.value;
    }
  },

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0__bus__["a" /* events */].$on('show:hover', this.showEventListener);
    __WEBPACK_IMPORTED_MODULE_0__bus__["a" /* events */].$on('hide:hover', this.hideEventListener);
  },


  methods: {
    showEventListener: function showEventListener(event) {
      var _this = this;

      this.$nextTick(function () {
        _this.visible = true;
        _this.value = event.value;
        var offset = event.el.getBoundingClientRect();
        _this.left = offset.left + 'px';
        _this.top = event.el.offsetHeight + offset.top + _this.offset + 'px';
      });
    },
    hideEventListener: function hideEventListener(event) {
      this.visible = false;
    }
  }
});

/***/ }),

/***/ "AzoL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_icon__ = __webpack_require__("IIW1");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'alert',

  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_2__components_icon__["a" /* default */]
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('alert', ['show', 'message', 'type'])),

  methods: {
    close: function close() {
      this.$store.dispatch('alert/remove');
    }
  }
});

/***/ }),

/***/ "B1iL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_973d79b6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_back_white_vue__ = __webpack_require__("FfDJ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_973d79b6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_back_white_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ba3P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);




var Imageable = function () {
  function Imageable(image) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Imageable);

    this.url = '';
    this.size = 0;
    this.width = 0;
    this.height = 0;
    this.date = '';

    if (image) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])(this, image);
    }
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Imageable, [{
    key: 'remove',
    value: function remove() {
      this.url = '';
      this.size = 0;
      this.width = 0;
      this.height = 0;
      this.date = '';
    }
  }, {
    key: 'any',
    get: function get() {
      return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(this.url);
    }
  }]);

  return Imageable;
}();

/* harmony default export */ __webpack_exports__["a"] = (Imageable);

/***/ }),

/***/ "DDuV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c4efd23_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_align_center_vue__ = __webpack_require__("ieao");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c4efd23_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_align_center_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DHiq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b3ff2760_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bug_vue__ = __webpack_require__("6KYS");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b3ff2760_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bug_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Dxc6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_user__ = __webpack_require__("/7YS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_error_status_code__ = __webpack_require__("mZd8");




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,

  state: {
    token: window.localStorage.getItem('token'),
    user: null
  },

  actions: {
    loginWithGoogle: function loginWithGoogle(_ref, _ref2) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch;
      var code = _ref2.code,
          redirect_uri = _ref2.redirect_uri;

      return __WEBPACK_IMPORTED_MODULE_1__models_user__["a" /* default */].loginWithGoogle(code, redirect_uri).then(function (user) {
        dispatch('login', user);
        return user;
      }).catch(function (err) {
        dispatch('alert/set', { code: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_error_status_code__["a" /* default */])(err) }, { root: true });
        commit('LOGOUT');
        throw err;
      });
    },
    loginWithToken: function loginWithToken(_ref3, _ref4) {
      var commit = _ref3.commit,
          dispatch = _ref3.dispatch;
      var token = _ref4.token;

      return __WEBPACK_IMPORTED_MODULE_1__models_user__["a" /* default */].loginWithToken(token).then(function (user) {
        dispatch('login', user);
        return user;
      }).catch(function (err) {
        dispatch('alert/set', { code: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_error_status_code__["a" /* default */])(err) }, { root: true });
        commit('LOGOUT');
        throw err;
      });
    },
    revokeToken: function revokeToken(_ref5) {
      var commit = _ref5.commit;

      commit('REVOKE');
    },
    invalidateToken: function invalidateToken(_ref6) {
      var commit = _ref6.commit;

      commit('INVALIDATE');
    },
    login: function login(_ref7, user) {
      var commit = _ref7.commit,
          dispatch = _ref7.dispatch;

      commit('galleries/SET_ITEMS', user.gallery, { root: true });
      commit('LOGIN', { user: user });
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(user);
    },
    logout: function logout(_ref8) {
      var commit = _ref8.commit;

      commit('LOGOUT');
    }
  },

  mutations: {
    LOGIN: function LOGIN(state, _ref9) {
      var user = _ref9.user;

      user = new __WEBPACK_IMPORTED_MODULE_1__models_user__["a" /* default */](user);
      state.user = user;
      state.token = user.token;
      window.localStorage.setItem('token', user.token);
      return user;
    },
    LOGOUT: function LOGOUT(state) {
      state.token = null;
      state.user = null;
      window.localStorage.removeItem('token');
    },


    // 模擬本機 token 遺失
    // 過期與 token 遺失會有不同的處理方式，因為沒有 token 即表示未曾登入過
    REVOKE: function REVOKE(state) {
      state.token = null;
      window.localStorage.removeItem('token');
    },


    // 模擬本機 token 過期
    // 竄改 token，刻意使 token 跟伺服器不一致而失效
    INVALIDATE: function INVALIDATE(state) {
      var token = '123';
      state.token = token;
      window.localStorage.setItem('token', token);
    }
  },

  getters: {
    isLoggedIn: function isLoggedIn(state) {
      return !!state.user;
    }
  }
});

/***/ }),

/***/ "ETak":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debug__ = __webpack_require__("Fy0/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_project__ = __webpack_require__("bW4M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);







var trace = __WEBPACK_IMPORTED_MODULE_3_debug___default()('vuex:projects');

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,

  state: {
    // 首頁專案清單預設每頁顯示的資料筆數
    itemsPerPage: 30,

    // id 清單儲存欄位
    list: [],

    // 物件實例快取
    cached: {},

    // 首頁清單讀取狀態
    loading: false,

    // 首頁清單篩選的專案 id 陣列（`[]`），若沒有過濾清單則為 `null`
    filterList: null
  },

  actions: {
    // 依照篩選條件（通常指專案狀態）、排序依賴的欄位名稱、排序規則，取得新的 id 清單
    getList: function getList(_ref) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch;

      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          type = _ref2.type,
          sort_type = _ref2.sort_type,
          sort_by = _ref2.sort_by,
          name = _ref2.name,
          serial = _ref2.serial;

      trace('getting list');
      return __WEBPACK_IMPORTED_MODULE_4__models_project__["a" /* default */].list({ type: type, sort_type: sort_type, sort_by: sort_by, name: name, serial: serial }).then(function (ids) {
        commit('SET_LIST', { ids: ids });
        dispatch('activeItems');
      }).catch(function (err) {
        commit('SET_LIST', { ids: [] });
        throw err;
      });
    },


    // 淘汰過期的物件，將需要重新向遠端獲取新的物件的專案 id 整理出來，
    // 或是篩選出尚未取得過物件實例的 id， 重新向伺服器再要一次整筆物件清單。
    activeItems: function activeItems(_ref3) {
      var commit = _ref3.commit,
          state = _ref3.state,
          dispatch = _ref3.dispatch,
          getters = _ref3.getters;

      var ids = getters.activeIds.filter(function (id) {
        var item = state.cached[id];
        if (item) {
          return item.isExpired;
        } else {
          return true;
        }
      });
      trace('active items: ', ids);
      return dispatch('fetchItems', { ids: ids });
    },


    // 向伺服器取得給予的 ids 物件實例
    fetchItems: function fetchItems(_ref4, _ref5) {
      var commit = _ref4.commit,
          getters = _ref4.getters;
      var ids = _ref5.ids;

      trace('fetching items: ', ids);

      if (!ids.length) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve([]);
      }

      trace('sending request to server...');
      commit('LOADING');
      return __WEBPACK_IMPORTED_MODULE_4__models_project__["a" /* default */].where(ids).then(function (projects) {
        projects.forEach(function (project) {
          return commit('ADD', { project: project });
        });
        return projects;
      }).finally(function () {
        commit('LOADED');
      });
    },


    // 向伺服器取得指定 id 的物件實例
    fetchItem: function fetchItem(_ref6, _ref7) {
      var commit = _ref6.commit,
          dispatch = _ref6.dispatch;
      var id = _ref7.id;

      trace('fetching item:', id);
      return __WEBPACK_IMPORTED_MODULE_4__models_project__["a" /* default */].get(id).then(function (project) {
        commit('ADD', { project: project });
        if (project.blocks) {
          dispatch('editor/blocks/add', { blocks: project.blocks }, { root: true });
        }
        return project;
      });
    },


    // 向伺服器新增專案資料
    create: function create(_ref8, _ref9) {
      var commit = _ref8.commit;
      var name = _ref9.name,
          galleries = _ref9.galleries,
          serial = _ref9.serial,
          sheet_url = _ref9.sheet_url,
          sheet_name = _ref9.sheet_name;

      return __WEBPACK_IMPORTED_MODULE_4__models_project__["a" /* default */].create({ name: name, galleries: galleries, serial: serial, sheet_url: sheet_url, sheet_name: sheet_name }).then(function (project) {
        commit('ADD', { project: project });
        return project;
      });
    },


    // 更新本機端物件資料，不會向伺服器發送更新請求
    assign: function assign(_ref10, _ref11) {
      var commit = _ref10.commit;
      var id = _ref11.id,
          data = _ref11.data;

      commit('UPDATE', { id: id, data: data });
    },


    // 更新指定 id 的伺服器端資料，同時更新本機端物件資料
    update: function update(_ref12, _ref13) {
      var rootGetters = _ref12.rootGetters,
          commit = _ref12.commit,
          dispatch = _ref12.dispatch;
      var id = _ref13.id,
          data = _ref13.data;

      return __WEBPACK_IMPORTED_MODULE_4__models_project__["a" /* default */].update(id, data).then(function (res) {
        // 向 API 儲存送的是「純 id」例如 [1, 3, 5]，但是資料使用上需要的是「實例物件」陣列，
        // 因此需要做反轉還原，把 id 轉回物件，再提交 UPDATE。
        //
        // 此外，由於更新專案並不一定是整個完整專案物件都往 API 丟，所以需要判斷 `data.galleries`
        // 是否存在，有資料才要做轉換處理
        //
        // TODO: 這個處理其實設計得不好，需要找個時間重構，理論上這邊應該要保持單純，不要有太多額外的操作
        if (data.galleries) {
          var galleries = rootGetters['galleries/items'];
          data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["merge"])(data, {
            galleries: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["map"])(data.galleries, function (id) {
              return galleries[id];
            })
          });
        }

        commit('UPDATE', { id: id, data: data, updatedAt: res.updated_at });
      }).catch(function (err) {
        if (err) {
          dispatch('alert/set', { code: err.code }, { root: true });
          throw err;
        }
      });
    },


    // 同時刪除多筆 ids 在伺服器端 / 本機端的資料
    delete: function _delete(_ref14, ids) {
      var commit = _ref14.commit;

      return __WEBPACK_IMPORTED_MODULE_4__models_project__["a" /* default */].delete(ids).then(function () {
        return commit('DELETE', ids);
      });
    },


    // 設定過濾清單，list 應為多筆專案 id 的集合
    setFilterList: function setFilterList(_ref15, list) {
      var commit = _ref15.commit;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve().then(function () {
        return commit('SET_FILTER_LIST', list);
      });
    },


    // 向伺服器獲取指定 id 及類型的專案預覽頁面
    getPreview: function getPreview(_ref16, _ref17) {
      var commit = _ref16.commit,
          dispatch = _ref16.dispatch;
      var id = _ref17.id,
          type = _ref17.type;

      return __WEBPACK_IMPORTED_MODULE_4__models_project__["a" /* default */].preview(id, type).catch(function (err) {
        if (err) {
          dispatch('alert/set', { code: err.code }, { root: true });
          throw err;
        }
      });
    },


    // 向伺服器發送對指定 id 的專案做同步商品資料的請求
    sync: function sync(_ref18, id) {
      var dispatch = _ref18.dispatch,
          commit = _ref18.commit;

      return __WEBPACK_IMPORTED_MODULE_4__models_project__["a" /* default */].sync(id).then(function (project) {
        if (project) {
          commit('UPDATE', { id: id, data: null, updatedAt: project.updated_at });
        }
        return project;
      }).catch(function (err) {
        if (err) {
          dispatch('alert/set', { code: err.code }, { root: true });
          throw err;
        }
      });
    },


    // 向伺服器獲取指定 id 專案的 EDM 下載資料
    download: function download(_ref19, id) {
      var commit = _ref19.commit;

      return __WEBPACK_IMPORTED_MODULE_4__models_project__["a" /* default */].download(id);
    },


    // 向伺服器發送對指定 id 專案做發佈的請求
    publish: function publish(_ref20, id) {
      var commit = _ref20.commit;

      return __WEBPACK_IMPORTED_MODULE_4__models_project__["a" /* default */].publish(id).then(function (data) {
        commit('UPDATE', { id: id, data: data });
        return data;
      });
    },
    copy: function copy(_ref21, _ref22) {
      var commit = _ref21.commit;
      var id = _ref22.id,
          name = _ref22.name,
          serial = _ref22.serial;

      return __WEBPACK_IMPORTED_MODULE_4__models_project__["a" /* default */].copy({ id: id, name: name, serial: serial }).then(function (project) {
        commit('ADD', { project: project });
        return project;
      });
    }
  },

  mutations: {
    SET_LIST: function SET_LIST(state, _ref23) {
      var ids = _ref23.ids;

      state.list = ids;
    },
    ADD: function ADD(state, _ref24) {
      var project = _ref24.project;

      // init project
      project = new __WEBPACK_IMPORTED_MODULE_4__models_project__["a" /* default */](project);

      // append to list
      if (!state.list.includes(project.id)) {
        state.list.unshift(project.id);
      }

      // set item
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state.cached, project.id, project);
    },
    UPDATE: function UPDATE(state, _ref25) {
      var id = _ref25.id,
          data = _ref25.data,
          updatedAt = _ref25.updatedAt;

      var project = state.cached[id];
      if (updatedAt) {
        project.updated_at = updatedAt;
      }
      if (data) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(project, data);
      }
    },
    DELETE: function DELETE(state, ids) {
      ids.forEach(function (id) {
        var index = state.list.indexOf(id);
        if (index !== -1) {
          __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].delete(state.list, index);
        }
        __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].delete(state.cached, id);
      });
    },
    LOADING: function LOADING(state) {
      state.loading = true;
    },
    LOADED: function LOADED(state) {
      state.loading = false;
    },
    SET_FILTER_LIST: function SET_FILTER_LIST(state, list) {
      state.filterList = list;
    }
  },

  getters: {
    filteredIds: function filteredIds(state) {
      var list = state.list,
          filterList = state.filterList;

      return filterList ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["intersection"])(list, filterList) : [];
    },
    activeIds: function activeIds(state, getters, rootState) {
      var itemsPerPage = state.itemsPerPage,
          list = state.list,
          filterList = state.filterList;
      var filteredIds = getters.filteredIds;


      var page = Number(rootState.route.query.page) || 1;
      var start = (page - 1) * itemsPerPage;
      var end = page * itemsPerPage;
      var items = filterList ? filteredIds : list;

      return items.slice(start, end);
    },


    // these items in the array may not be fully fetched.
    items: function items(state, getters) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["map"])(getters.activeIds, function (id) {
        return state.cached[id];
      }).filter(function (_) {
        return _;
      });
    },
    item: function item(state) {
      return function (id) {
        return state.cached[id];
      };
    }
  }
});

/***/ }),

/***/ "FEhf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tooltip_vue__ = __webpack_require__("Awda");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_068d9f64_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tooltip_vue__ = __webpack_require__("egux");
function injectStyle (ssrContext) {
  __webpack_require__("yXRU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-068d9f64"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tooltip_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_068d9f64_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tooltip_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FOwU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}}),_c('path',{attrs:{"d":"M18.4 10.6a10.46 10.46 0 0 0-16.86 4.62L3.9 16a8 8 0 0 1 12.72-3.62L13 16h9V7l-3.6 3.6z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FfD9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_weak_map__ = __webpack_require__("XFB5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_weak_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_weak_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_error_status_code__ = __webpack_require__("mZd8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_tool__ = __webpack_require__("y6zN");









var _lastUpdated = new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_weak_map___default.a();

var Model = function () {
  function Model() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Model);

    _lastUpdated.set(this, Date.now());
  }

  // 取得最後更新時間


  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Model, [{
    key: 'lastUpdated',
    get: function get() {
      return _lastUpdated.get(this);
    }

    // 是否已經過期？

  }, {
    key: 'isExpired',
    get: function get() {
      return Date.now() - this.lastUpdated > 1000 * 60 * 3;
    }
  }], [{
    key: 'onAPIError',


    /**
     * inject response status code to error object on error happened
     * @private
     */
    value: function onAPIError(err) {
      var code = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_error_status_code__["a" /* default */])(err);
      if (code) {
        err.code = code;
      }

      if (err.code === 401) {
        window.open(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_tool__["c" /* getSignInURL */])(), 'signin', 'width=640,height=700');
      }

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
    }

    /**
     * @private
     */

  }, {
    key: 'onHTTPError',
    value: function onHTTPError(err) {
      var code = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_error_status_code__["a" /* default */])(err);
      if (code) {
        err.code = code;
      }

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
    }
  }, {
    key: 'baseURL',
    get: function get() {
      return 'https://eventor.friday.tw/service';
    }

    /**
     * api 介面提供需要認證的 HTTP request，它會在 HTTP headers 塞入 token 或是相關需要驗證的資料。
     *
     * @return {Object} The axios instance object
     *
     * @example
     *
     * ``` js
     * this.api.get(`projects`)
     * this.api.get(`private/resources`)
     * ```
     *
     */

  }, {
    key: 'api',
    get: function get() {
      if (!this._api) {
        this._api = __WEBPACK_IMPORTED_MODULE_4_axios___default.a.create();
        this._api.defaults.baseURL = this.baseURL;
        this._api.defaults.headers.common['Accept'] = 'application/json';
        this._api.defaults.headers.post['Content-Type'] = 'application/json; charset=UTF-8';
        this._api.interceptors.response.use(function (res) {
          return res;
        }, this.onAPIError);
      }
      this._api.defaults.headers.common['Authorization'] = __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].state.account.token;
      return this._api;
    }
  }, {
    key: 'http',
    get: function get() {
      if (!this._http) {
        this._http = __WEBPACK_IMPORTED_MODULE_4_axios___default.a.create();
        this._http.defaults.baseURL = this.baseURL;
        this._http.defaults.headers.post['Content-Type'] = 'application/json; charset=UTF-8';
        this._http.defaults.headers.common['Accept'] = 'application/json';
        this._http.interceptors.response.use(function (res) {
          return res;
        }, this.onHTTPError);
      }
      return this._http;
    }
  }]);

  return Model;
}();

/* harmony default export */ __webpack_exports__["a"] = (Model);

/***/ }),

/***/ "FfDJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 240.823 240.823","width":"512","height":"512","fill":"#fff"}},[_c('path',{attrs:{"d":"M57.633 129.007l108.297 108.26c4.752 4.74 12.45 4.74 17.215 0 4.752-4.74 4.752-12.438 0-17.178l-99.707-99.672 99.695-99.67c4.752-4.74 4.752-12.44 0-17.192-4.752-4.74-12.463-4.74-17.215 0L57.62 111.816c-4.678 4.69-4.678 12.51.013 17.19z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GoAe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"height":"24","width":"24","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}}),_c('path',{attrs:{"d":"M10 4v3h2.21l-3.42 8H6v3h8v-3h-2.21l3.42-8H18V4z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HJ/f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__editor_blocks__ = __webpack_require__("aMN+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__editor_mods__ = __webpack_require__("uZr/");






var state = function state() {
  return {
    hideSidebar: false,
    isAppendable: false,

    // ready state used for detect editor first loaded or editing.
    ready: false,
    changed: false,
    // media support: 'desktop', 'mobile'
    media: 'desktop',
    zoom: 1,

    menuFocusing: null
  };
};

var actions = {
  fetchProject: function fetchProject(_ref, _ref2) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;
    var id = _ref2.id;

    return dispatch('projects/fetchItem', { id: id }, { root: true }).catch(function (err) {
      throw err;
    });
  },
  reset: function reset(_ref3) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;

    dispatch('editor/blocks/reset', null, { root: true });
    dispatch('editor/mods/reset', null, { root: true });
    commit('RESET');
  },
  toggleSidebar: function toggleSidebar(_ref4) {
    var state = _ref4.state,
        commit = _ref4.commit;

    var type = state.hideSidebar ? 'OPEN_SIDEBAR' : 'CLOSE_SIDEBAR';
    commit(type);
  },
  appendable: function appendable(_ref5) {
    var commit = _ref5.commit;

    commit('APPENDABLE');
  },
  unappendable: function unappendable(_ref6) {
    var commit = _ref6.commit;

    commit('UNAPPENDABLE');
  },


  // 變更專案資料但是不儲存，遠端資料亦不會改變
  assign: function assign(_ref7, data) {
    var commit = _ref7.commit,
        dispatch = _ref7.dispatch,
        getters = _ref7.getters;

    var project = getters.project;
    dispatch('change');
    dispatch('projects/assign', { id: project.id, data: data }, { root: true });
  },


  // 儲存專案，將會變更遠端資料
  //
  // 目前只會傳送 blocks 與 project.meta 兩筆屬性
  save: function save(_ref8) {
    var state = _ref8.state,
        commit = _ref8.commit,
        dispatch = _ref8.dispatch,
        getters = _ref8.getters;

    var project = getters.project;
    var blocks = state.blocks.list.map(function (id) {
      return state.blocks.cached[id];
    });
    var data = {
      blocks: blocks,
      meta: project.meta
    };
    return dispatch('projects/update', { id: project.id, data: data }, { root: true }).then(function () {
      return commit('SAVED');
    });
  },
  ready: function ready(_ref9) {
    var commit = _ref9.commit;

    commit('READY');
  },


  // 使專案狀態改為已經變更且尚未儲存
  change: function change(_ref10) {
    var state = _ref10.state,
        commit = _ref10.commit;

    if (state.ready) {
      commit('CHANGE');
    }
  },


  // 切換編輯器目前的專案檢視模式
  viewAs: function viewAs(_ref11, type) {
    var commit = _ref11.commit;

    commit('VIEW_AS', type);
  },


  // 同步商品資料
  sync: function sync(_ref12, id) {
    var state = _ref12.state,
        dispatch = _ref12.dispatch,
        commit = _ref12.commit;

    if (state.changed) {
      var err = new Error('編輯中的專案尚未儲存，請儲存後再進行商品同步資料，以避免資料遺失。');
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(err);
    }
    return dispatch('projects/sync', id, { root: true }).then(function (project) {
      dispatch('editor/blocks/reset', null, { root: true });
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick(function () {
        return dispatch('editor/blocks/add', { blocks: project.blocks }, { root: true });
      });

      // add synced blocks will making editor changed
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick(function () {
        return commit('SAVED');
      });
    }).catch(function (err) {
      dispatch('alert/set', { code: err.code }, { root: true });
    });
  },


  // 編輯器放大檢視比例
  zoomin: function zoomin(_ref13) {
    var commit = _ref13.commit;

    return commit('ZOOMIN');
  },


  // 編輯器縮小檢視比例
  zoomout: function zoomout(_ref14) {
    var commit = _ref14.commit;

    return commit('ZOOMOUT');
  },


  // 編輯器重置檢視比例
  zoomReset: function zoomReset(_ref15) {
    var commit = _ref15.commit;

    return commit('ZOOM_RESET');
  },
  menuFocus: function menuFocus(_ref16, uid) {
    var commit = _ref16.commit;

    return commit('MENU_FOCUS', uid);
  }
};

var mutations = {
  RESET: function RESET(_state) {
    var init = state();
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(init).forEach(function (key) {
      _state[key] = init[key];
    });
  },
  OPEN_SIDEBAR: function OPEN_SIDEBAR(state) {
    state.hideSidebar = false;
  },
  CLOSE_SIDEBAR: function CLOSE_SIDEBAR(state) {
    state.hideSidebar = true;
  },
  APPENDABLE: function APPENDABLE(state) {
    state.isAppendable = true;
  },
  UNAPPENDABLE: function UNAPPENDABLE(state) {
    state.isAppendable = false;
  },
  CHANGE: function CHANGE(state) {
    state.changed = true;
  },
  SAVED: function SAVED(state) {
    state.changed = false;
  },
  READY: function READY(state) {
    state.ready = true;
  },
  VIEW_AS: function VIEW_AS(state, type) {
    state.media = type;
  },
  ZOOMIN: function ZOOMIN(state) {
    if (state.zoom >= 1) {
      state.zoom = 1;
      return;
    }
    state.zoom += 0.25;
  },
  ZOOMOUT: function ZOOMOUT(state) {
    if (state.zoom <= 0.25) {
      state.zoom = 0.25;
      return;
    }
    state.zoom -= 0.25;
  },
  ZOOM_RESET: function ZOOM_RESET(state) {
    state.zoom = 1;
  },
  MENU_FOCUS: function MENU_FOCUS(state, uid) {
    state.menuFocusing = uid;
  }
};

var getters = {
  project: function project(state, getters, rootState, rootGetters) {
    var id = rootState.route.params.project_id;
    return rootGetters['projects/item'](id) || {};
  },
  hideSidebar: function hideSidebar(state) {
    return state.hideSidebar;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  modules: { mods: __WEBPACK_IMPORTED_MODULE_4__editor_mods__["a" /* default */], blocks: __WEBPACK_IMPORTED_MODULE_3__editor_blocks__["a" /* default */] },
  state: state(),
  actions: actions,
  mutations: mutations,
  getters: getters
});

/***/ }),

/***/ "Hlcb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"}}),_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ICW2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M15.5 14h-.8l-.3-.3c1-1 1.6-2.6 1.6-4.2C16 6 13 3 9.5 3S3 6 3 9.5 6 16 9.5 16c1.6 0 3-.6 4.2-1.6l.3.3v.8l5 5 1.5-1.5-5-5zm-6 0C7 14 5 12 5 9.5S7 5 9.5 5 14 7 14 9.5 12 14 9.5 14z"}}),_c('path',{attrs:{"d":"M0 0h24v24H0V0z","fill":"none"}}),_c('path',{attrs:{"d":"M12 10h-2v2H9v-2H7V9h2V7h1v2h2v1z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IIW1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_icon_vue__ = __webpack_require__("v7QK");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_icon_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IRrs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg","fill":"#fff"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}}),_c('path',{attrs:{"d":"M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules__ = __webpack_require__("2mV7");





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* default */].Store({
  modules: __WEBPACK_IMPORTED_MODULE_2__modules__["a" /* default */]
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ "ImbY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dca871c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sort_vue__ = __webpack_require__("UGTi");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dca871c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sort_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JlpQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"alert",class:{
      'alert-danger': _vm.type === 'danger',
      'alert-success': _vm.type === 'success',
      'alert-warn': _vm.type === 'warn'
    }},[_c('div',{staticClass:"message",domProps:{"innerHTML":_vm._s(_vm.message)}}),_vm._v(" "),_c('div',{staticClass:"close-wrapper",on:{"click":_vm.close}},[_c('icon',{staticClass:"icon-close",attrs:{"type":"close"}})],1)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JxKn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"gray-lighter":"#f9fafb","gray-light":"#f3f5f7","gray-base":"#dee3e7","gray-dark":"#c3cdd5","gray-darker":"#313b45","ink-lightest":"#929fab","ink-lighter":"#607080","ink-light":"#444f5a","ink-base":"#212b35","blue-lighter":"#ebf5fa","blue-light":"#afe1f8","blue-base":"#437adf","blue-dark":"#005085","blue-darker":"#001529","green-lighter":"#e3f1df","green-light":"#bbe5b3","green-base":"#51b93c","green-dark":"#107f42","green-darker":"#17362f","yellow-lighter":"#fcf2cf","yellow-light":"#ffe98a","yellow-base":"#f0c400","yellow-dark":"#9a6d19","yellow-darker":"#573b00","red-lighter":"#fbeae5","red-light":"#feb09a","red-base":"#ed6145","red-dark":"#c00710","red-darker":"#320101","purple-lighter":"#f7f2fd","purple-light":"#e3d1ff","purple-base":"#9b68de","purple-dark":"#50248f","purple-darker":"#230052","orange-lighter":"#fcead9","orange-light":"#ffc48a","orange-base":"#f49343","orange-dark":"#c05716","orange-darker":"#491504"};

/***/ }),

/***/ "K7D5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}}),_c('path',{attrs:{"d":"M19.4 10c-.7-3.4-3.8-6-7.4-6-1.5 0-3 .4-4 1.2l1.5 1.4C10 6.2 11 6 12 6c3 0 5.5 2.5 5.5 5.5v.5H19c1.7 0 3 1.3 3 3 0 1-.6 2-1.6 2.6L22 19c1.2-.8 2-2.3 2-4 0-2.6-2-4.8-4.7-5zM3 5.3L5.8 8C2.5 8.2 0 10.8 0 14c0 3.3 2.7 6 6 6h11.7l2 2 1.3-1.3L4.3 4 3 5.3zM7.7 10l8 8H6c-2.2 0-4-1.8-4-4s1.8-4 4-4h1.7z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Kr4n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}}),_c('path',{attrs:{"d":"M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ktwz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34e0fe67_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_error_outline_vue__ = __webpack_require__("mHKu");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34e0fe67_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_error_outline_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LBso":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c7c387c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_search_vue__ = __webpack_require__("mshR");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c7c387c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Lut1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30d128d4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_close_vue__ = __webpack_require__("8EoV");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30d128d4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_close_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M12S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}}),_c('path',{attrs:{"d":"M22 16V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2zm-11-4l2.03 2.71L16 11l4 5H8l3-4zM2 6v14c0 1.1.9 2 2 2h14v-2H4V6H2z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bb98932_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("zcbD");
function injectStyle (ssrContext) {
  __webpack_require__("JxKn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bb98932_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_promise_prototype_finally__ = __webpack_require__("puN1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_promise_prototype_finally___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_promise_prototype_finally__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__ = __webpack_require__("9JMe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_directives__ = __webpack_require__("AaU6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_directives___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__utils_directives__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_filters__ = __webpack_require__("iClD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__plugins_tooltip__ = __webpack_require__("xVh7");

// shim











__WEBPACK_IMPORTED_MODULE_1_promise_prototype_finally___default.a.shim();

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].config.productionTip = false;

// register global utility directives.
__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_7__utils_directives__).forEach(function (key) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].directive(key, __WEBPACK_IMPORTED_MODULE_7__utils_directives__[key]);
});

// register global utility filters.
__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_8__utils_filters__).forEach(function (key) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].filter(key, __WEBPACK_IMPORTED_MODULE_8__utils_filters__[key]);
});

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9__plugins_tooltip__["a" /* default */]);

/* eslint-disable no-new */
window.app = new __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */]);
  }
});

/***/ }),

/***/ "NLfJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20ea9ca2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_toggle_sidebar_right_vue__ = __webpack_require__("X0Xg");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20ea9ca2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_toggle_sidebar_right_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NzTo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ea06b66_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_font_size_vue__ = __webpack_require__("iIcG");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ea06b66_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_font_size_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OHCg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"height":"24","viewBox":"1 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg","fill":"#fff"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}}),_c('path',{attrs:{"d":"M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Oqj+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22328402_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_logo_vue__ = __webpack_require__("+nMQ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22328402_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_logo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PvgN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"height":"24","width":"24","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}}),_c('path',{attrs:{"d":"M12 17a6 6 0 0 0 6-6V3h-2.5v8a3.5 3.5 0 0 1-7 0V3H6v8a6 6 0 0 0 6 6zm-7 2v2h14v-2H5z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PxI5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a3aac81_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_text_vue__ = __webpack_require__("X5dx");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a3aac81_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_text_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RTy2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg","fill":"#fff"}},[_c('path',{attrs:{"d":"M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"}}),_c('path',{attrs:{"d":"M0-.5h24v24H0z","fill":"none"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ri+C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}}),_c('path',{attrs:{"d":"M19.4 13v-2l2-1.6c.3-.2.4-.5.3-.7l-2-3.4c-.2-.3-.4-.3-.6-.3l-2 1-2-1-.3-2.6c0-.2-.3-.4-.5-.4h-4c-.2 0-.4.2-.4.4L9 5 7.5 6 5 5c-.3 0-.5 0-.7.3l-2 3.4c0 .3 0 .5.2.7l2 1.6v2l-2 1.6c-.2.2-.3.5-.2.7l2 3.4c.2.3.4.3.6.3l2-1 2 1 .3 2.6c0 .2.2.4.5.4h4c.2 0 .4-.2.4-.4L15 19l1.6-1 2.5 1c.8 0 1 0 1-.3l2-3.4v-.7L20 13zM12 15.5c-2 0-3.5-1.6-3.5-3.5S10 8.5 12 8.5s3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TNU0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28d8c5a4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_preview_vue__ = __webpack_require__("IRrs");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28d8c5a4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_preview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TYWd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);



/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,

  state: {
    percent: 0,
    canSuccess: true,
    show: false
  },

  actions: {
    start: function start(_ref) {
      var state = _ref.state,
          dispatch = _ref.dispatch,
          commit = _ref.commit;

      commit('SHOW');
      this._timer = setInterval(function () {
        commit('INCREASE_PERCENT');
        if (state.percent > 95) {
          dispatch('clearTimer');
        }
      }, 200);
    },
    finish: function finish(_ref2) {
      var state = _ref2.state,
          dispatch = _ref2.dispatch,
          commit = _ref2.commit;

      var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { failed: false },
          failed = _ref3.failed;

      if (!state.show) {
        return;
      }
      commit('INCREASE_PERCENT', 100);
      if (failed) {
        commit('FAILED');
      }
      dispatch('hide');
    },
    hide: function hide(_ref4) {
      var state = _ref4.state,
          dispatch = _ref4.dispatch,
          commit = _ref4.commit;

      dispatch('clearTimer');
      setTimeout(function () {
        commit('HIDE');
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].nextTick(function () {
          setTimeout(function () {
            commit('INCREASE_PERCENT', 0);
            commit('SUCCESSED');
          }, 200);
        });
      }, 500);
    },
    clearTimer: function clearTimer() {
      window.clearInterval(this._timer);
      this._timer = null;
    }
  },

  mutations: {
    SHOW: function SHOW(state) {
      state.show = true;
    },
    HIDE: function HIDE(state) {
      state.show = false;
    },
    INCREASE_PERCENT: function INCREASE_PERCENT(state, n) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["isNull"])(n)) {
        state.percent += 1;
        return;
      }
      state.percent = 100;
    },
    SUCCESSED: function SUCCESSED(state) {
      state.canSuccess = true;
    },
    FAILED: function FAILED(state) {
      state.canSuccess = false;
    }
  },

  getters: {
    current: function current(state) {}
  }
});

/***/ }),

/***/ "TZFD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"height":"24","width":"24","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M4 10.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm0-6a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm0 12c-.83 0-1.5.68-1.5 1.5s.68 1.5 1.5 1.5 1.5-.68 1.5-1.5-.67-1.5-1.5-1.5zM7 19h14v-2H7v2zm0-6h14v-2H7v2zm0-8v2h14V5H7z"}}),_c('path',{attrs:{"d":"M0 0h24v24H0V0z","fill":"none"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TbTy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ab58f0f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_fullscreen_vue__ = __webpack_require__("2AJj");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ab58f0f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_fullscreen_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UGTi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M16 17v-7h-2v7h-3l4 4 4-4h-3zM9 3L5 7h3v7h2V7h3L9 3z"}}),_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Uf/J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("zwoO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__("Pf15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__block__ = __webpack_require__("1Y7b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_imageable__ = __webpack_require__("Ba3P");








var Text = function (_Block) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Text, _Block);

  function Text(block) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Text);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Text.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Text)).call(this, block));

    _this.type = 'text';
    _this.alias = '\u6587\u5B57 - ' + _this.uid;
    _this.html = '';
    _this.mobile = {
      background_image: new __WEBPACK_IMPORTED_MODULE_6__models_imageable__["a" /* default */](),
      background_color: ''
    };
    _this.desktop = {
      background_image: new __WEBPACK_IMPORTED_MODULE_6__models_imageable__["a" /* default */](),
      background_color: ''
    };

    if (block) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["merge"])(_this, block);
    }
    return _this;
  }

  return Text;
}(__WEBPACK_IMPORTED_MODULE_5__block__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Text);

/***/ }),

/***/ "W/Fe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7662e6d7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_palette_vue__ = __webpack_require__("c4r0");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7662e6d7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_palette_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Wk86":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"512","height":"512","viewBox":"0 0 292.359 292.359","fill":"#ccc"}},[_c('path',{attrs:{"d":"M222.98 5.424C219.363 1.807 215.08 0 210.13 0c-4.95 0-9.233 1.807-12.848 5.424L69.378 133.33c-3.615 3.618-5.424 7.9-5.424 12.848 0 4.95 1.81 9.233 5.424 12.847l127.906 127.907c3.614 3.617 7.898 5.428 12.848 5.428 4.948 0 9.232-1.81 12.847-5.428 3.616-3.614 5.426-7.898 5.426-12.847V18.27c0-4.948-1.81-9.228-5.427-12.846z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "X0Xg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"512","height":"512","viewBox":"0 0 292.359 292.359","fill":"#e0e0e0"}},[_c('path',{attrs:{"d":"M222.98 133.33L95.072 5.425C91.456 1.807 87.178 0 82.226 0s-9.233 1.807-12.85 5.424c-3.617 3.617-5.424 7.898-5.424 12.847v255.814c0 4.948 1.807 9.232 5.424 12.847 3.62 3.618 7.902 5.43 12.85 5.43 4.95 0 9.23-1.812 12.847-5.43L222.98 159.025c3.613-3.613 5.427-7.897 5.427-12.847 0-4.948-1.813-9.23-5.428-12.846z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "X5dx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('defs',[_c('path',{attrs:{"d":"M24 24H0V0h24v24z","id":"a"}})]),_c('clipPath',{attrs:{"id":"b"}},[_c('use',{attrs:{"overflow":"visible","xlink:href":"#a"}})]),_c('path',{attrs:{"clip-path":"url(#b)","d":"M2.5 4v3h5v12h3V7h5V4h-13zm19 5h-9v3h3v7h3v-7h3V9z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XtEy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_feafb8fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_assets_info_svg__ = __webpack_require__("Yjt0");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_feafb8fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_assets_info_svg__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YWmX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11e16d4c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_images_vue__ = __webpack_require__("M12S");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11e16d4c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_images_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debug__ = __webpack_require__("Fy0/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__errors_permission_error__ = __webpack_require__("ZTPE");






var NotFound = function NotFound() {
  return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, "6YU9"));
};
var InternalError = function InternalError() {
  return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, "qqNg"));
};

// Layouts
var MainLayout = function MainLayout() {
  return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, "lwem"));
};
var PagesLayout = function PagesLayout() {
  return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, "/rnQ"));
};

// Sessions
var OAuthCallback = function OAuthCallback() {
  return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, "uxYM"));
};
var Signin = function Signin() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "aETP"));
};

// Projects
var ProjectsIndex = function ProjectsIndex() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, "nVVk"));
};
var ProjectsNew = function ProjectsNew() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "38Kg"));
};
var ProjectCopy = function ProjectCopy() {
  return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, "IUh6"));
};
var ProjectEdit = function ProjectEdit() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "94Xz"));
};
var ProjectEditMods = function ProjectEditMods() {
  return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, "J5xe"));
};
var ProjectEditModal = function ProjectEditModal() {
  return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, "Ctto"));
};
var ProjectEditHistory = function ProjectEditHistory() {
  return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, "RhVQ"));
};
var ProjectEditGeneral = function ProjectEditGeneral() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "03Cm"));
};
var ProjectEditShared = function ProjectEditShared() {
  return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, "kzLA"));
};
var ProjectEditSettings = function ProjectEditSettings() {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, "e4fI"));
};
var ProjectEditInfo = function ProjectEditInfo() {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, "497x"));
};
var ProjectEditBlock = function ProjectEditBlock() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "VTiJ"));
};
var ProjectPreview = function ProjectPreview() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, "Me9g"));
};
var ImageMapTool = function ImageMapTool() {
  return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, "ApDK"));
};
var TextEditor = function TextEditor() {
  return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, "vIR/"));
};

// Pages
var PagesGuide = function PagesGuide() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "oM7Z"));
};
var PagesChangelog = function PagesChangelog() {
  return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, "oKb8"));
};

var trace = __WEBPACK_IMPORTED_MODULE_3_debug___default()('router');

// for store last sub view
var LastSubView;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'root',
    redirect: { name: 'signin' },
    component: MainLayout,
    meta: { loginRequired: true },
    children: [{
      path: 'projects',
      name: 'projects#index',
      component: ProjectsIndex,
      children: [{
        path: 'new',
        name: 'projects#new',
        component: ProjectsNew,
        meta: { canCreateProjectRequired: true }
      }, {
        path: 'copy',
        name: 'projects#copy',
        component: ProjectCopy,
        meta: { canCreateProjectRequired: true }
      }]
    }, {
      path: 'projects/created_by_me',
      name: 'projects#created_by_me',
      component: ProjectsIndex
    }, {
      path: 'projects/published',
      name: 'projects#published',
      component: ProjectsIndex
    }, {
      path: 'projects/unpublished',
      name: 'projects#unpublished',
      component: ProjectsIndex
    }]
  }, {
    path: '/signin',
    name: 'signin',
    component: Signin,
    beforeEnter: function beforeEnter(to, from, next) {
      var isLoggedIn = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters['account/isLoggedIn'];
      if (isLoggedIn) {
        next({ name: 'projects#index' });
      } else {
        next();
      }
    }
  }, {
    path: '/signout',
    name: 'signout',
    beforeEnter: function beforeEnter(to, from, next) {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('account/logout').then(function () {
        return router.push({ name: 'root' });
      });
    }
  }, {
    path: '/auth/:provider/callback',
    component: OAuthCallback
  }, {
    path: '/projects/:project_id',
    name: 'projects#show',
    redirect: { name: 'projects#edit' },
    meta: { loginRequired: true }
  }, {
    path: '/projects/:project_id/edit',
    component: ProjectEdit,
    meta: {
      loginRequired: true,
      canEditProjectRequired: true
    },
    children: [{
      path: '',
      name: 'projects#edit',
      component: ProjectEditMods
    }, {
      path: '',
      components: {
        modal: ProjectEditModal,
        default: LastSubView
      },
      children: [{
        path: 'history',
        name: 'projects#edit_history',
        component: ProjectEditHistory
      }, {
        path: 'general',
        name: 'projects#edit_general',
        component: ProjectEditGeneral
      }, {
        path: 'shared',
        name: 'projects#edit_shared',
        component: ProjectEditShared
      }],
      beforeEnter: function beforeEnter(to, from, next) {
        var map = {
          'projects#edit': ProjectEditMods,
          'projects#edit_settings': ProjectEditSettings,
          'projects#edit_block': ProjectEditBlock,
          'projects#info': ProjectEditInfo
        };
        LastSubView = map[from.name] || ProjectEditMods;
        next();
      }
    }, {
      path: 'settings',
      name: 'projects#edit_settings',
      component: ProjectEditSettings
    }, {
      path: 'blocks',
      redirect: { name: 'projects#edit' }
    }, {
      path: 'info',
      name: 'projects#info',
      component: ProjectEditInfo
    }, {
      path: 'blocks/:block_id',
      name: 'projects#edit_block',
      component: ProjectEditBlock
    }, {
      path: 'blocks/:block_id/image_map_tool',
      name: 'projects#image_map_tool',
      components: {
        tool: ImageMapTool
      }
    }, {
      path: 'blocks/:block_id/text_editor',
      name: 'projects#text_editor',
      components: {
        tool: TextEditor
      }
    }]
  }, {
    path: '/projects/:project_id/preview',
    name: 'projects#preview',
    component: ProjectPreview
  }, {
    path: '',
    component: PagesLayout,
    children: [{
      path: '/guide',
      name: 'pages#guide',
      component: PagesGuide
    }, {
      path: 'changelog',
      name: 'pages#changelog',
      component: PagesChangelog
    }]
  }, {
    path: '/404',
    name: 'not_found',
    component: NotFound
  }, {
    path: '/500',
    name: 'internal_error',
    component: InternalError
  }, {
    path: '/*',
    redirect: { name: 'not_found' }
  }]
});

router.beforeEach(function (to, from, next) {
  // rememer to return early in condition scopes.

  // this route requires login, check if logged in
  // if not, redirect to login page.
  if (to.matched.some(function (record) {
    return record.meta.loginRequired;
  })) {
    if (!__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters['account/isLoggedIn']) {
      return next({ name: 'signin', query: { redirect: to.fullPath } });
    }
  }

  if (to.matched.some(function (record) {
    return record.meta.canEditProjectRequired;
  })) {
    if (!__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.account.user.canEditProject) {
      var error = new __WEBPACK_IMPORTED_MODULE_4__errors_permission_error__["a" /* default */]('您沒有編輯專案的權限');
      return next(error);
    }
  }

  if (to.matched.some(function (record) {
    return record.meta.canCreateProjectRequired;
  })) {
    if (!__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.account.user.canCreateProject) {
      var _error = new __WEBPACK_IMPORTED_MODULE_4__errors_permission_error__["a" /* default */]('您沒有新增專案的權限');
      return next(_error);
    }
  }

  // make sure to always call next()!
  next();
});

router.afterEach(function (to, from) {
  __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('progress/finish');
  var $loading = document.getElementById('loading-wrapper');
  if ($loading) {
    $loading.remove();
  }
});

router.onError(function (err) {
  trace('on error', err);

  if (!err) {
    return;
  }

  if (err instanceof __WEBPACK_IMPORTED_MODULE_4__errors_permission_error__["a" /* default */]) {
    router.push({ name: 'projects#index' }, function () {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('alert/set', { error: err });
    }, function () {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('alert/set', { error: err });
    });
    return;
  }

  if (err.code === 404) {
    trace('Got an HTTP status 404 on router error handler, so redirect to `not_found` page.');
    router.push({ name: 'not_found' });
    return;
  }

  if (err.code === 401) {
    trace('Got an HTTP status 401 on router error handler, so redirect to `signin` page.');
    router.push({ name: 'signin' });
  }

  if (err.code >= 500) {
    trace('Got an HTTP status >= 500 on router error handler, so redirect to `internal_error` page.');
    router.push({ name: 'internal_error' });
  } else {
    // set alert if not redirect to the 500 error page,
    // because error page already shown the error message.
    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('alert/set', { code: err.code });
  }

  __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('progress/finish', { failed: true });
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "YjWl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bedb010_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_desktop_vue__ = __webpack_require__("5kFl");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bedb010_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_desktop_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Yjt0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}}),_c('path',{attrs:{"d":"M11 17h2v-6h-2v6zm1-15C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zM11 9h2V7h-2v2z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Yych":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("zwoO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__("Pf15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__block__ = __webpack_require__("1Y7b");







var IframeBlock = function (_Block) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(IframeBlock, _Block);

  function IframeBlock(block) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, IframeBlock);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (IframeBlock.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(IframeBlock)).call(this, block));

    _this.type = 'iframe';
    _this.alias = 'iframe - ' + _this.uid;
    _this.src = '';
    _this.image = {
      url: '',
      size: 0,
      width: 0,
      height: 0,
      title: ''
    };
    _this.linkable = {
      type: 'href',
      href: '',
      title: ''
    };

    if (block) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["merge"])(_this, block);
    }
    return _this;
  }

  return IframeBlock;
}(__WEBPACK_IMPORTED_MODULE_5__block__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (IframeBlock);

/***/ }),

/***/ "ZC6/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M11 17h10v-2H11v2zm-8-5l4 4V8l-4 4zm0 9h18v-2H3v2zM3 3v2h18V3H3zm8 6h10V7H11v2zm0 4h10v-2H11v2z"}}),_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZTPE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__ = __webpack_require__("OvRC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__("kiBT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_reflect_construct__ = __webpack_require__("pQ2V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_reflect_construct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_reflect_construct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("zwoO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__("Pf15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__);









function _extendableBuiltin(cls) {
  function ExtendableBuiltin() {
    var instance = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_reflect_construct___default()(cls, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()(arguments));

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(instance, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of___default()(this));

    return instance;
  }

  ExtendableBuiltin.prototype = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default()(cls.prototype, {
    constructor: {
      value: cls,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });

  if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default.a) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_set_prototype_of___default()(ExtendableBuiltin, cls);
  } else {
    ExtendableBuiltin.__proto__ = cls;
  }

  return ExtendableBuiltin;
}

var PermissionError = function (_extendableBuiltin2) {
  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(PermissionError, _extendableBuiltin2);

  function PermissionError(message) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, PermissionError);

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this, (PermissionError.__proto__ || __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of___default()(PermissionError)).call(this, message || '您沒有足夠的權限，請聯繫系統管理員'));
  }

  return PermissionError;
}(_extendableBuiltin(Error));

/* harmony default export */ __webpack_exports__["a"] = (PermissionError);

/***/ }),

/***/ "Zv3s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af600550_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_remove_vue__ = __webpack_require__("mtmh");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af600550_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_remove_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "a8xC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_imageable__ = __webpack_require__("Ba3P");





var ProjectMeta = function () {
  function ProjectMeta(meta) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ProjectMeta);

    this.title = '';
    this.desc = '';
    this.keywords = '';
    this.og = {
      image: new __WEBPACK_IMPORTED_MODULE_3__models_imageable__["a" /* default */]()
    };
    this.background_image = new __WEBPACK_IMPORTED_MODULE_3__models_imageable__["a" /* default */]();
    this.background_color = '';
    this.email_subject = '';
    this.email_desc = '';
    this.wt_mc_id = '';
    this.utm_campaign = '';
    this.utm_source = '';
    this.utm_medium = '';
    this.header_src = {
      web: '',
      edm: ''
    };
    this.footer_src = {
      web: '',
      edm: ''
    };

    if (meta) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])(this, meta);
    }
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ProjectMeta, [{
    key: 'anyOGimage',
    get: function get() {
      return this.og.image.any;
    }
  }, {
    key: 'isValid',
    get: function get() {
      return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(this.email_subject) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(this.title);
    }
  }]);

  return ProjectMeta;
}();

/* harmony default export */ __webpack_exports__["a"] = (ProjectMeta);

/***/ }),

/***/ "aMN+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_blocks__ = __webpack_require__("1+qV");




var state = function state() {
  return {
    list: [],
    cached: {},
    inViewport: []
  };
};

var actions = {
  add: function add(_ref, _ref2) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;
    var mod = _ref2.mod,
        blocks = _ref2.blocks,
        index = _ref2.index;

    if (mod) {
      var block = __WEBPACK_IMPORTED_MODULE_2__models_blocks__["a" /* default */].create(mod.type);
      commit('ADD', { block: block, index: index });
      dispatch('editor/change', null, { root: true });
    }
    if (blocks) {
      blocks.forEach(function (block, index) {
        block = __WEBPACK_IMPORTED_MODULE_2__models_blocks__["a" /* default */].create(block.type, block);
        commit('ADD', { block: block, index: index });
        dispatch('editor/change', null, { root: true });
      });
    }
  },
  move: function move(_ref3, _ref4) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;
    var id = _ref4.id,
        index = _ref4.index;

    commit('MOVE', { id: id, index: index });
    dispatch('editor/change', null, { root: true });
  },
  remove: function remove(_ref5, _ref6) {
    var commit = _ref5.commit,
        dispatch = _ref5.dispatch;
    var id = _ref6.id;

    commit('REMOVE', { id: id });
    dispatch('editor/change', null, { root: true });
  },
  reset: function reset(_ref7) {
    var commit = _ref7.commit;

    commit('RESET');
  },
  update: function update(_ref8, _ref9) {
    var commit = _ref8.commit,
        dispatch = _ref8.dispatch;
    var uid = _ref9.uid,
        data = _ref9.data;

    commit('UPDATE', { uid: uid, data: data });
    dispatch('editor/change', null, { root: true });
  },
  enterViewport: function enterViewport(_ref10, uid) {
    var commit = _ref10.commit;

    commit('ENTER_VIEWPORT', uid);
  },
  exitViewport: function exitViewport(_ref11, uid) {
    var commit = _ref11.commit;

    commit('EXIT_VIEWPORT', uid);
  }
};

var mutations = {
  ADD: function ADD(state, _ref12) {
    var block = _ref12.block,
        index = _ref12.index;

    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].set(state.cached, block.uid, block);
    if (state.list.indexOf(block.uid) === -1) {
      state.list.splice(index, 0, block.uid);
    }
  },
  MOVE: function MOVE(state, _ref13) {
    var id = _ref13.id,
        index = _ref13.index;

    var from = state.list.indexOf(id);
    var to = index;
    // Doesn't need to change position on click the target context.
    if (to === from || to === from + 1) {
      return;
    }
    state.list.splice(from < to ? to - 1 : to, 0, state.list.splice(from, 1)[0]);
  },
  REMOVE: function REMOVE(state, _ref14) {
    var id = _ref14.id;

    state.list.splice(state.list.indexOf(id), 1);
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].delete(state.cached, id);
  },


  // The first argument is the state context of this moudle, that conflict with
  // the function for reset state. `_state` used to bypass this issue.
  RESET: function RESET(_state) {
    var init = state();
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(init).forEach(function (key) {
      _state[key] = init[key];
    });
  },
  UPDATE: function UPDATE(state, _ref15) {
    var uid = _ref15.uid,
        data = _ref15.data;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data).forEach(function (key) {
      var target = state.cached[uid];
      var value = data[key];

      __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].set(target, key, value);
    });
  },
  ENTER_VIEWPORT: function ENTER_VIEWPORT(state, uid) {
    var index = state.inViewport.indexOf(uid);
    if (index !== -1) {
      return;
    }
    state.inViewport.push(uid);
  },
  EXIT_VIEWPORT: function EXIT_VIEWPORT(state, uid) {
    var index = state.inViewport.indexOf(uid);
    if (index === -1) {
      return;
    }
    state.inViewport.splice(index, 1);
  }
};

var getters = {
  item: function item(state) {
    return function (id) {
      return state.cached[id];
    };
  },


  // 將區塊清單轉換為可讀的清單
  anchors: function anchors(state) {
    return state.list.map(function (id) {
      return state.cached[id];
    }).filter(function (_) {
      return _;
    }).map(function (block) {
      return {
        id: block.uid,
        type: block.type,
        text: block.alias
      };
    });
  },
  selected: function selected(state, getters, rootState, rootGetters) {
    var id = rootState.route.params.block_id;
    return state.cached[id];
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({ namespaced: true, state: state(), actions: actions, mutations: mutations, getters: getters });

/***/ }),

/***/ "bW4M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("zwoO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__("Pf15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__model__ = __webpack_require__("FfD9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_project_meta__ = __webpack_require__("a8xC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_time__ = __webpack_require__("2hfY");










var Project = function (_Model) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Project, _Model);

  function Project(project) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Project);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Project.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Project)).call(this));

    _this.id = project.id;
    _this.serial = project.serial;
    _this.livesync_since = project.livesync_since || 30;
    _this.published_url = project.published_url;
    _this.sheet_url = project.sheet_url;
    _this.sheet_name = project.sheet_name;
    _this.name = project.name;
    _this.owner = project.owner;
    _this.galleries = project.galleries;
    _this.meta = new __WEBPACK_IMPORTED_MODULE_6__models_project_meta__["a" /* default */](project.meta);
    _this.blocks = project.blocks;
    _this.publish_at = project.publish_at;
    _this.published_at = project.published_at;
    _this.updated_at = project.updated_at;
    _this.created_at = project.created_at;
    return _this;
  }

  // TODO: 需要更有彈性的驗證機制


  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Project, [{
    key: 'isValid',
    get: function get() {
      return this.meta.isValid;
    }

    /**
     * 發佈日期加上 livesync_since 天數格式化後的日期格式
     *
     * @return {String}
     */

  }, {
    key: 'livesyncStamps',
    get: function get() {
      if (!this.isPublished) {
        return null;
      }

      var days = 24 * 60 * 60 * 1000;
      var publishedAt = new Date(this.published_at);
      var livesyncAt = new Date();

      livesyncAt.setTime(publishedAt.getTime() + this.livesync_since * days);

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_time__["a" /* default */])(livesyncAt);
    }

    /**
     * 檢查專案是否已經發佈，如果有發佈 published_at 應該會是空字串
     *
     * @return {Boolean}
     */

  }, {
    key: 'isPublished',
    get: function get() {
      return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["isEmpty"])(this.published_at);
    }

    /**
     * 檢查專案是否有更新但是還沒有發佈
     *
     * @return {Boolean}
     */

  }, {
    key: 'isExpiredAfterPublished',
    get: function get() {
      return this.isPublished && new Date(this.updated_at) > new Date(this.published_at);
    }

    //
    //
    // Static Methods
    // ================================================================

    /**
     * Get project by a given id.
     *
     * @param  {Number} id  The id of the project.
     * @return {Promise}
     */

  }], [{
    key: 'get',
    value: function get(id) {
      return this.api.get('projects/' + id).then(function (res) {
        return res.data;
      });
    }

    /**
     * Get Projects by a list of ids.
     *
     * @param  {Array} ids  An array of ids.
     * @return {Promise}
     */

  }, {
    key: 'where',
    value: function where(ids) {
      return this.api.get('projects', { params: { ids: ids.join(',') } }).then(function (res) {
        return res.data;
      });
    }

    /**
     * 依照排序類型、排序規則，取得專案的 ids list。
     *
     * @param  {String} options.type      Available: `index`, `published`, `unpublished`, `created_by_me`, default is `index`.
     * @param  {String} options.sort_type Available: `name`, `created_at`, `updated_at`, `serial`, `published_at`, `created_at`
     * @param  {String} options.sort_by   Available: `desc`, `asc`
     * @param  {String} options.name      Available: '專案名稱'
     * @param  {String} options.serial      Available: '發報碼'
     * @return {Promise}
     */

  }, {
    key: 'list',
    value: function list(_ref) {
      var type = _ref.type,
          sort_type = _ref.sort_type,
          sort_by = _ref.sort_by,
          name = _ref.name,
          serial = _ref.serial;

      return this.api.get('projects/list', { params: { type: type, sort_type: sort_type, sort_by: sort_by, name: name, serial: serial } }).then(function (res) {
        return res.data;
      });
    }

    /**
     * Tries to create a new project record.
     *
     * @param  {String} options.name         專案名稱
     * @param  {Array} options.galleries     專案所屬的管別 ID 陣列，ex [3, 8, 12]
     * @param  {String} options.serial       發報碼
     * @param  {String} options.sheet_url    Google 試算表網址
     * @param  {String} options.sheet_name   試算表分頁名稱
     * @return {Promise}
     */

  }, {
    key: 'create',
    value: function create(_ref2) {
      var name = _ref2.name,
          galleries = _ref2.galleries,
          serial = _ref2.serial,
          sheet_url = _ref2.sheet_url,
          sheet_name = _ref2.sheet_name;

      return this.api.post('projects', { name: name, galleries: galleries, serial: serial, sheet_url: sheet_url, sheet_name: sheet_name }).then(function (res) {
        return res.data;
      });
    }
  }, {
    key: 'copy',
    value: function copy(_ref3) {
      var id = _ref3.id,
          name = _ref3.name,
          serial = _ref3.serial;

      return this.api.post('projects/' + id + '/copy', { name: name, serial: serial }).then(function (res) {
        return res.data;
      });
    }

    /**
     * Updates the project by given project id.
     *
     * @param  {Number} id     The id of the project
     * @param  {Object} data   The project attributes
     * @return {Promise}
     */

  }, {
    key: 'update',
    value: function update(id, data) {
      return this.api.patch('projects/' + id, data).then(function (res) {
        return res.data;
      });
    }

    /**
     * Tries to delete projects that have given ids of projects.
     *
     * @param  {Array} ids   The ids of projects.
     * @return {Promise}
     */

  }, {
    key: 'delete',
    value: function _delete(ids) {
      return this.api.delete('projects', { params: { ids: ids.join(',') } });
    }

    /**
     * Get the preview result(HTML) by the given project id and previewing type.
     *
     * @param  {Number} id     The project id
     * @param  {String} type   previewing type
     * @return {Promise}
     */

  }, {
    key: 'preview',
    value: function preview(id, type) {
      return this.api.get('projects/' + id + '/preview', {
        headers: {
          Accept: 'text/html'
        },
        params: { type: type }
      });
    }

    /**
     * Send a request to server sync product data
     *
     * @param  {Number} id    The project id
     * @return {Promise}
     */

  }, {
    key: 'sync',
    value: function sync(id) {
      return this.api.post('projects/' + id + '/sync').then(function (res) {
        return res.data;
      });
    }

    /**
     * Download the EDM HTML from server.
     *
     * @param  {Number} id   The project id.
     * @return {Promise}
     */

  }, {
    key: 'download',
    value: function download(id) {
      return this.api.get('projects/' + id + '/download', {
        responseType: 'blob'
      }).then(function (res) {
        var url = window.URL.createObjectURL(new Blob([res.data]));
        var link = document.createElement('a');
        var fileName = getResponseFileName(res);
        link.href = url;
        // follwing the file naming rule from server, but gives it a fallback.
        link.setAttribute('download', fileName || 'edm-' + Date.now() + '.html');
        document.body.appendChild(link);
        link.click();
        // remember to revoke ObjectURL object prevent memory leaks.
        window.URL.revokeObjectURL(url);
      });
    }

    /**
     * Request server to publish the project by the given project id.
     *
     * @param  {Number} id  The project id.
     * @return {Promise}
     */

  }, {
    key: 'publish',
    value: function publish(id) {
      return this.api.post('projects/' + id + '/publish').then(function (res) {
        return res.data;
      });
    }
  }]);

  return Project;
}(__WEBPACK_IMPORTED_MODULE_5__model__["a" /* default */]);

function getResponseFileName(res) {
  return res.headers['content-disposition'].match(/filename="(.+)"/)[1];
}

/* harmony default export */ __webpack_exports__["a"] = (Project);

/***/ }),

/***/ "c4r0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"height":"24","width":"24","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M12 3a9 9 0 0 0 0 18 1.5 1.5 0 0 0 1.11-2.51A1.5 1.5 0 0 1 14.23 16H16a5 5 0 0 0 5-5c0-4.42-4.03-8-9-8zm-5.5 9a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm3-4a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm3 4a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"}}),_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "c8vr":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB2aWV3Qm94PSIwIDAgNDQ4LjggNDQ4LjgiPjxwYXRoIGZpbGw9IiNGRkYiIGQ9Ik0xNDIuOCAzMjMuODVMMzUuNyAyMTYuNzUgMCAyNTIuNDVsMTQyLjggMTQyLjggMzA2LTMwNi0zNS43LTM1LjciLz48L3N2Zz4="

/***/ }),

/***/ "c9kr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"#000000","height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M15.6 10.79c.97-.67 1.65-1.77 1.65-2.79 0-2.26-1.75-4-4-4H7v14h7.04c2.09 0 3.71-1.7 3.71-3.79 0-1.52-.86-2.82-2.15-3.42zM10 6.5h3c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-3v-3zm3.5 9H10v-3h3.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cKMs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e866c2c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_setting_vue__ = __webpack_require__("Ri+C");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e866c2c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_setting_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "clsu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"height":"24","width":"24","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}}),_c('path',{attrs:{"d":"M3.9 12A3.1 3.1 0 0 1 7 8.9h4V7H7a5 5 0 0 0 0 10h4v-1.9H7A3.1 3.1 0 0 1 3.9 12zM8 13h8v-2H8v2zm9-6h-4v1.9h4a3.1 3.1 0 0 1 0 6.2h-4V17h4a5 5 0 0 0 0-10z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cs2W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0 0h24v24H0V0z","fill":"none"}}),_c('path',{attrs:{"d":"M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm2.46-7.12l1.41-1.41L12 12.59l2.12-2.12 1.41 1.41L13.41 14l2.12 2.12-1.41 1.41L12 15.41l-2.12 2.12-1.41-1.41L10.59 14l-2.13-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4z"}}),_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "e1H0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);




var Linkable = function () {
  function Linkable(link) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Linkable);

    this.type = 'href';
    this.href = '';
    this.title = '';

    if (link) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])(this, link);
    }
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Linkable, [{
    key: 'remove',
    value: function remove() {
      this.type = 'href';
      this.href = '';
      this.title = '';
    }
  }]);

  return Linkable;
}();

/* harmony default export */ __webpack_exports__["a"] = (Linkable);

/***/ }),

/***/ "egux":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"tooltip"}},[(_vm.shown)?_c('div',{staticClass:"tooltip",style:({ top: _vm.top, left: _vm.left })},[_vm._v("\n    "+_vm._s(_vm.value)+"\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "f56N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_542933fe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_fullscreen_exit_vue__ = __webpack_require__("uQRD");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_542933fe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_fullscreen_exit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "f6E1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512.001 512.001","fill":"#c85146"}},[_c('path',{attrs:{"d":"M498.75 136.71L375.29 13.25C366.745 4.707 355.383 0 343.298 0H168.702c-12.085 0-23.447 4.706-31.993 13.25L13.25 136.71C4.707 145.255 0 156.617 0 168.702V343.3c0 12.084 4.706 23.446 13.25 31.992L136.71 498.75c8.545 8.545 19.907 13.25 31.993 13.25H343.3c12.085 0 23.447-4.706 31.993-13.25L498.75 375.29c8.545-8.544 13.25-19.906 13.25-31.992V168.702c0-12.085-4.707-23.447-13.25-31.992zm-3.93 206.588c0 7.496-2.92 14.543-8.22 19.843L363.142 486.6c-5.3 5.3-12.348 8.218-19.843 8.218H168.7c-7.496 0-14.543-2.92-19.843-8.22L25.4 363.143c-5.3-5.3-8.218-12.348-8.218-19.844V168.702c0-7.496 2.92-14.543 8.22-19.843L148.857 25.4c5.3-5.3 12.348-8.218 19.844-8.218H343.3c7.495 0 14.542 2.92 19.842 8.22L486.6 148.857c5.3 5.3 8.218 12.348 8.218 19.843V343.3z"}}),_c('path',{attrs:{"d":"M246.837 192.43H173.53c-4.744 0-8.59 3.846-8.59 8.59s3.845 8.592 8.59 8.592h73.306c4.744 0 8.59-3.846 8.59-8.59s-3.845-8.592-8.59-8.592zM210.183 229.083c-4.744 0-8.59 3.846-8.59 8.59v73.307c0 4.744 3.845 8.59 8.59 8.59 4.744 0 8.59-3.845 8.59-8.59v-73.306c0-4.745-3.845-8.59-8.59-8.59zM310.98 192.43c-24.947 0-45.244 20.297-45.244 45.244v36.653c0 24.947 20.297 45.244 45.244 45.244s45.244-20.296 45.244-45.243v-36.653c0-24.948-20.297-45.244-45.244-45.244zm28.062 81.897c0 15.473-12.59 28.063-28.063 28.063s-28.064-12.59-28.064-28.063v-36.653c0-15.473 12.59-28.063 28.063-28.063s28.062 12.59 28.062 28.064v36.653zM416.358 192.43h-32.072c-4.744 0-8.59 3.846-8.59 8.59s3.845 8.592 8.59 8.592h32.072c12.948 0 23.48 10.533 23.48 23.48s-10.532 23.482-23.48 23.482h-23.48v-18.9c0-4.743-3.847-8.59-8.592-8.59-4.744 0-8.59 3.846-8.59 8.59v73.307c0 4.745 3.845 8.592 8.59 8.592 4.744 0 8.59-3.846 8.59-8.59v-37.227h23.482c22.42 0 40.662-18.24 40.662-40.662 0-22.423-18.24-40.663-40.662-40.663zM113.97 192.43c-3.79 0-7.542.414-11.153 1.23-4.63 1.045-7.532 5.644-6.488 10.27 1.045 4.63 5.644 7.534 10.27 6.49 2.372-.537 4.85-.81 7.368-.81 12.728 0 23.48 7.082 23.48 15.464 0 4.744 3.847 8.59 8.592 8.59 4.744 0 8.59-3.845 8.59-8.59 0-18-18.24-32.644-40.66-32.644zM116.857 247.91c-20.455-7.305-26.37-12.428-26.37-22.836 0-4.744-3.846-8.59-8.59-8.59s-8.592 3.845-8.592 8.59c0 23.554 18.66 32.19 37.773 39.016 20.455 7.305 26.37 12.428 26.37 22.836 0 8.382-10.753 15.463-23.48 15.463s-23.482-7.082-23.482-15.464c0-4.744-3.846-8.59-8.59-8.59s-8.592 3.845-8.592 8.59c0 18 18.24 32.644 40.662 32.644 22.42 0 40.662-14.644 40.662-32.644.003-23.554-18.657-32.19-37.77-39.016z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fSq5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_alert_vue__ = __webpack_require__("AzoL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e2571ad_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_alert_vue__ = __webpack_require__("JlpQ");
function injectStyle (ssrContext) {
  __webpack_require__("1Aps")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1e2571ad"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_alert_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e2571ad_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_alert_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fV6m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_gallery__ = __webpack_require__("3vsC");



/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,

  state: {
    cached: {}
  },

  mutations: {
    SET_ITEMS: function SET_ITEMS(state, galleries) {
      galleries.forEach(function (gallery) {
        gallery = new __WEBPACK_IMPORTED_MODULE_1__models_gallery__["a" /* default */](gallery);
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state.cached, gallery.id, gallery);
      });
    }
  },

  getters: {
    items: function items(state) {
      return state.cached;
    }
  }
});

/***/ }),

/***/ "fvHD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M3 21h18v-2H3v2zm6-4h12v-2H9v2zm-6-4h18v-2H3v2zm6-4h12V7H9v2zM3 3v2h18V3H3z"}}),_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "g+IU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"}}),_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "g8gR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0 0h24v24H0V0z","fill":"none"}}),_c('path',{attrs:{"d":"M15.5 14h-.8l-.3-.3c1-1 1.6-2.6 1.6-4.2C16 6 13 3 9.5 3S3 6 3 9.5 6 16 9.5 16c1.6 0 3-.6 4.2-1.6l.3.3v.8l5 5 1.5-1.5-5-5zm-6 0C7 14 5 12 5 9.5S7 5 9.5 5 14 7 14 9.5 12 14 9.5 14zM7 9h5v1H7z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gKke":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}}),_c('path',{attrs:{"d":"M4 6H2v14c0 1 1 2 2 2h14v-2H4V6zm16-4H8C7 2 6 3 6 4v12c0 1 1 2 2 2h12c1 0 2-1 2-2V4c0-1-1-2-2-2zm-8 12.5v-9l6 4.5-6 4.5z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gifX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}}),_c('path',{attrs:{"d":"M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hCpS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1428a3ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_arrow_down_vue__ = __webpack_require__("r9iZ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1428a3ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_arrow_down_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hZay":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f2b5314_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mobile_vue__ = __webpack_require__("iDuX");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f2b5314_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mobile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iClD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["simpleFormat"] = simpleFormat;
/* harmony export (immutable) */ __webpack_exports__["trunc"] = trunc;
/* harmony export (immutable) */ __webpack_exports__["datetime"] = datetime;
/* harmony export (immutable) */ __webpack_exports__["marked"] = marked;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_time__ = __webpack_require__("2hfY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_marked__ = __webpack_require__("EFqf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_marked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_marked__);




function simpleFormat(str) {
  return str.replace(/(?:\r\n|\r|\n)/g, '<br />');
}

function trunc(string) {
  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 30;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["truncate"])(string, { length: length });
}

function datetime(string) {
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(string)) {
    return string;
  }
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_time__["a" /* default */])(string);
}

function marked(string) {
  return __WEBPACK_IMPORTED_MODULE_2_marked___default()(string);
}

/***/ }),

/***/ "iDuX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M15.5 1h-8C6.12 1 5 2.12 5 3.5v17C5 21.88 6.12 23 7.5 23h8c1.38 0 2.5-1.12 2.5-2.5v-17C18 2.12 16.88 1 15.5 1zm-4 21c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4.5-4H7V4h9v14z"}}),_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iIcG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}}),_c('path',{attrs:{"d":"M9 4v3h5v12h3V7h5V4H9zm-6 8h3v7h3v-7h3V9H3v3z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ieao":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M7 15v2h10v-2H7zm-4 6h18v-2H3v2zm0-8h18v-2H3v2zm4-6v2h10V7H7zM3 3v2h18V3H3z"}}),_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "k2nX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"height":"24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}}),_c('path',{attrs:{"d":"M20 13H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1zM7 19c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM20 3H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1zM7 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kofh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e9629b1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_outdent_vue__ = __webpack_require__("ZC6/");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e9629b1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_outdent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lThe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cd945212_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_zoomout_vue__ = __webpack_require__("g8gR");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cd945212_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_zoomout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lWON":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c5f33452_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_video_vue__ = __webpack_require__("gKke");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c5f33452_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_video_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "loVc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b23e74b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_underline_vue__ = __webpack_require__("PvgN");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b23e74b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_underline_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mHKu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0 0h24v24H0V0z","fill":"none"}}),_c('path',{attrs:{"d":"M11 15h2v2h-2zm0-8h2v6h-2zm1-5C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm0 18c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mZd8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getErrorStatusCode;
function getErrorStatusCode(err) {
  var code;
  if (err.response) {
    code = err.response.status;
  } else if (err.request) {
    code = err.request.status;
  }
  return code;
}

/***/ }),

/***/ "mshR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 250.313 250.313","width":"512","height":"512"}},[_c('path',{attrs:{"d":"M244.186 214.604l-54.38-54.378c-.288-.29-.627-.49-.93-.76 10.7-16.23 16.946-35.66 16.946-56.554C205.822 46.075 159.747 0 102.912 0S0 46.075 0 102.91c0 56.836 46.074 102.912 102.91 102.912 20.895 0 40.323-6.245 56.554-16.945.27.3.47.64.76.93l54.38 54.38c8.168 8.167 21.412 8.167 29.582 0 8.168-8.17 8.168-21.414 0-29.583zM102.91 170.146c-37.133 0-67.235-30.102-67.235-67.235 0-37.133 30.103-67.235 67.236-67.235s67.236 30.103 67.236 67.236c0 37.134-30.103 67.236-67.235 67.236z","fill":"#063728","fill-rule":"evenodd","clip-rule":"evenodd"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mtmh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M19 13H5v-2h14v2z"}}),_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nIXq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("zwoO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__("Pf15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__block__ = __webpack_require__("1Y7b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_imageable__ = __webpack_require__("Ba3P");








var StickMenu = function (_Block) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(StickMenu, _Block);

  function StickMenu(block) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, StickMenu);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (StickMenu.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(StickMenu)).call(this, block));

    _this.type = 'sticky_menu';
    _this.alias = '\u8DDF\u5C41\u87F2 - ' + _this.uid;
    _this.excluded_ids = [];
    _this.header_image = new __WEBPACK_IMPORTED_MODULE_6__models_imageable__["a" /* default */]();
    _this.footer_image = new __WEBPACK_IMPORTED_MODULE_6__models_imageable__["a" /* default */]();
    _this.background_color = '';
    _this.item_background_color = '';
    _this.color = '';

    if (block) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["merge"])(_this, block);
    }
    return _this;
  }

  return StickMenu;
}(__WEBPACK_IMPORTED_MODULE_5__block__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (StickMenu);

/***/ }),

/***/ "nS8g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M3 17.3V21h3.8l11-11L14 6 3 17zM20.7 7c.4-.4.4-1 0-1.4l-2.3-2.3c-.4-.4-1-.4-1.4 0L15 5l4 4 1.7-2z"}}),_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "npSS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}}),_c('path',{attrs:{"d":"M21 19V5c0-1-1-2-2-2H5C4 3 3 4 3 5v14c0 1 1 2 2 2h14c1 0 2-1 2-2zM8.5 13.5l2.5 3 3.5-4.5 4.5 6H5l3.5-4.5z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oHeb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"}}),_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ozkX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ffac202_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_delete_vue__ = __webpack_require__("cs2W");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ffac202_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_delete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qGLw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M3 21h18v-2H3v2zM3 8v8l4-4-4-4zm8 9h10v-2H11v2zM3 3v2h18V3H3zm8 6h10V7H11v2zm0 4h10v-2H11v2z"}}),_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qdue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}}),_c('path',{attrs:{"d":"M12 18.5l-7.4-5.7L3 14l9 7 9-7-1.6-1.2-7.4 5.7zm0-2.5l7.4-5.7L21 9l-9-7-9 7 1.6 1.3L12 16z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qlif":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("zwoO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__("Pf15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__block__ = __webpack_require__("1Y7b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_imageable__ = __webpack_require__("Ba3P");








var ImageBlock = function (_Block) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(ImageBlock, _Block);

  function ImageBlock(block) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ImageBlock);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ImageBlock.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ImageBlock)).call(this, block));

    _this.type = 'image';
    _this.alias = '\u5716\u7247 - ' + _this.uid;
    _this.mobile = {
      image: new __WEBPACK_IMPORTED_MODULE_6__models_imageable__["a" /* default */]()
    };
    _this.desktop = {
      image: new __WEBPACK_IMPORTED_MODULE_6__models_imageable__["a" /* default */]()
    };
    _this.linkable = {
      type: 'href',
      href: '',
      title: ''
    };

    if (block) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["merge"])(_this, block);
    }
    return _this;
  }

  return ImageBlock;
}(__WEBPACK_IMPORTED_MODULE_5__block__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (ImageBlock);

/***/ }),

/***/ "r9iZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M7 10l5 5 5-5z"}}),_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rFOT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = {}, _obj[_vm.$style.bar] = true, _obj[_vm.$style.success] = _vm.canSuccess, _obj[_vm.$style.failed] = !_vm.canSuccess, _obj ),style:({
    'width': _vm.percent + '%',
    'opacity': _vm.show ? 1 : 0
  })})
var _obj;}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rFay":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49b5ade5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_arrow_up_vue__ = __webpack_require__("wOHD");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49b5ade5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_arrow_up_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rHal":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54ebc244_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_edit_vue__ = __webpack_require__("nS8g");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54ebc244_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rQYt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_512c836b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_publish_vue__ = __webpack_require__("Kr4n");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_512c836b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_publish_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rczV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return events; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");

var events = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

/***/ }),

/***/ "rwyL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M15 15H3v2h12v-2zm0-8H3v2h12V7zM3 13h18v-2H3v2zm0 8h18v-2H3v2zM3 3v2h18V3H3z"}}),_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "s7Xz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ef97e748_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_download_vue__ = __webpack_require__("oHeb");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ef97e748_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_download_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sVQ6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("zwoO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__("Pf15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__block__ = __webpack_require__("1Y7b");







var ImagesBlock = function (_Block) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(ImagesBlock, _Block);

  function ImagesBlock(block) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ImagesBlock);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ImagesBlock.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ImagesBlock)).call(this, block));

    _this.type = 'images';
    _this.alias = '\u96D9\u5716 - ' + _this.uid;
    _this.mobile = {
      images: [{
        url: '',
        size: 0,
        width: 0,
        height: 0,
        title: ''
      }, {
        url: '',
        size: 0,
        width: 0,
        height: 0,
        title: ''
      }]
    };
    _this.desktop = {
      images: [{
        url: '',
        size: 0,
        width: 0,
        height: 0,
        title: ''
      }, {
        url: '',
        size: 0,
        width: 0,
        height: 0,
        title: ''
      }]
    };
    _this.linkables = [{
      type: 'href',
      href: '',
      title: ''
    }, {
      type: 'href',
      href: '',
      title: ''
    }];

    if (block) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["merge"])(_this, block);
    }
    return _this;
  }

  return ImagesBlock;
}(__WEBPACK_IMPORTED_MODULE_5__block__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (ImagesBlock);

/***/ }),

/***/ "uQRD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"height":"24","width":"24","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}}),_c('path',{attrs:{"d":"M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uZr/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,

  state: {
    selected: null
  },

  actions: {
    select: function select(_ref, _ref2) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch;
      var mod = _ref2.mod;

      commit('SELECT', { mod: mod });
      dispatch('editor/appendable', null, { root: true });
    },
    unselect: function unselect(_ref3) {
      var commit = _ref3.commit,
          dispatch = _ref3.dispatch;

      commit('UNSELECT');
      dispatch('editor/unappendable', null, { root: true });
    },
    reset: function reset(_ref4) {
      var commit = _ref4.commit,
          dispatch = _ref4.dispatch;

      dispatch('unselect');
      commit('RESET');
    }
  },

  mutations: {
    SELECT: function SELECT(state, _ref5) {
      var mod = _ref5.mod;

      state.selected = mod;
    },
    UNSELECT: function UNSELECT(state) {
      state.selected = null;
    },
    RESET: function RESET(state) {
      state.selected = null;
    }
  }
});

/***/ }),

/***/ "v7QK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__icons__ = __webpack_require__("/cD4");



/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  name: 'icon',

  props: ['type'],

  render: function render(h, ctx) {
    function appropriateIconComponent() {
      return __WEBPACK_IMPORTED_MODULE_0__icons__["a" /* default */][ctx.props.type];
    }

    return h(appropriateIconComponent(), ctx.data, ctx.children);
  }
});

/***/ }),

/***/ "vDhE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0 0h24v24H0V0z","fill":"none"}}),_c('path',{attrs:{"d":"M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vUdT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6345967a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_new_window_vue__ = __webpack_require__("xc+g");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6345967a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_new_window_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vaBA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}}),_c('path',{attrs:{"d":"M3.27 5L2 6.27l6.97 6.97L6.5 19h3l1.57-3.66L16.73 21 18 19.73 3.55 5.27 3.27 5zM6 5v.18L8.82 8h2.4l-.72 1.68 2.1 2.1L14.21 8H20V5H6z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wOHD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M7 14l5-5 5 5z"}}),_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_alert__ = __webpack_require__("fSq5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_progress_bar__ = __webpack_require__("4lHW");
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',

  components: {
    Alert: __WEBPACK_IMPORTED_MODULE_0__components_alert__["a" /* default */],
    ProgressBar: __WEBPACK_IMPORTED_MODULE_1__components_progress_bar__["a" /* default */]
  }
});

/***/ }),

/***/ "xVh7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tooltip__ = __webpack_require__("FEhf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bus__ = __webpack_require__("rczV");



var addHoverEventListener = function addHoverEventListener(el, value) {
  var mouseover = function mouseover(srcEvent) {
    __WEBPACK_IMPORTED_MODULE_1__bus__["a" /* events */].$emit('show:hover', { value: value, el: el, srcEvent: srcEvent });
  };

  var mouseleave = function mouseleave(srcEvent) {
    __WEBPACK_IMPORTED_MODULE_1__bus__["a" /* events */].$emit('hide:hover', { value: value, el: el, srcEvent: srcEvent });
  };

  el.addEventListener('mouseover', mouseover);
  el.addEventListener('mouseleave', mouseleave);

  el.$popoverRemoveHoverHandlers = function () {
    __WEBPACK_IMPORTED_MODULE_1__bus__["a" /* events */].$emit('hide:hover');
    el.removeEventListener('mouseover', mouseover);
    el.removeEventListener('mouseleave', mouseleave);
  };
};

/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue) {
    Vue.component('tooltip', __WEBPACK_IMPORTED_MODULE_0__Tooltip__["a" /* default */]);

    Vue.directive('tooltip', {
      bind: function bind(el, binding) {
        addHoverEventListener(el, binding.value);
      },
      unbind: function unbind(el, binding) {
        el.$popoverRemoveHoverHandlers();
      }
    });
  }
});

/***/ }),

/***/ "xatV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fef944e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bold_vue__ = __webpack_require__("c9kr");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fef944e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bold_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xc+g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg","fill":"#ffffff"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}}),_c('path',{attrs:{"d":"M19 19H5V5h7V3H5C4 3 3 4 3 5v14c0 1 1 2 2 2h14c1 0 2-1 2-2v-7h-2v7zM14 3v2h3.6l-9.8 9.8 1.4 1.4L19 6.4V10h2V3h-7z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "y1wj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1710018a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_back_vue__ = __webpack_require__("RTy2");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1710018a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_back_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "y6dV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("zwoO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__("Pf15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__block__ = __webpack_require__("1Y7b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__models_imageable__ = __webpack_require__("Ba3P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__models_linkable__ = __webpack_require__("e1H0");










var ProductBlock = function (_Block) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ProductBlock, _Block);

  function ProductBlock(block) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ProductBlock);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ProductBlock.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ProductBlock)).call(this, block));

    _this.type = 'product';
    _this.alias = '\u5546\u54C1 - ' + _this.uid;
    _this.template = '';
    _this.theme = '';
    _this.title = '';
    _this.title_visible = false;
    _this.items = [];
    _this.mobile = {
      header: {
        background_image: new __WEBPACK_IMPORTED_MODULE_7__models_imageable__["a" /* default */](),
        background_color: '',
        color: ''
      },
      body: {
        background_image: new __WEBPACK_IMPORTED_MODULE_7__models_imageable__["a" /* default */](),
        background_color: ''
      },
      banner: {
        image: new __WEBPACK_IMPORTED_MODULE_7__models_imageable__["a" /* default */](),
        linkable: new __WEBPACK_IMPORTED_MODULE_8__models_linkable__["a" /* default */]()
      }
    };
    _this.desktop = {
      header: {
        background_image: new __WEBPACK_IMPORTED_MODULE_7__models_imageable__["a" /* default */](),
        background_color: '',
        color: ''
      },
      body: {
        background_image: new __WEBPACK_IMPORTED_MODULE_7__models_imageable__["a" /* default */](),
        background_color: ''
      },
      banner: {
        image: new __WEBPACK_IMPORTED_MODULE_7__models_imageable__["a" /* default */](),
        linkable: new __WEBPACK_IMPORTED_MODULE_8__models_linkable__["a" /* default */]()
      }
    };

    if (block) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["merge"])(_this, block);
    }
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ProductBlock, [{
    key: 'anyBanner',
    get: function get() {
      return this.template === 'PD_1B6S_A' || this.template === 'PD_1B6S_B' || this.template === 'PD_1B3S_A';
    }
  }]);

  return ProductBlock;
}(__WEBPACK_IMPORTED_MODULE_6__block__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (ProductBlock);

/***/ }),

/***/ "y6zN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getAspectRatio;
/* harmony export (immutable) */ __webpack_exports__["c"] = getSignInURL;
/* harmony export (immutable) */ __webpack_exports__["b"] = copy;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

/**
 * Caculate aspect ratio by given width and height.
 *
 * @param  {Number} width
 * @param  {Number} height
 * @return {Number}
 */
function getAspectRatio(width, height) {
  return height / width * 100;
}

/**
 * 取得 Google 登入頁面的網址
 *
 * @param  {String} redirect redirect URL after signed in
 * @return {String}          Google signin URL dialog
 */
function getSignInURL(redirect) {
  var baseURL = 'https://accounts.google.com/o/oauth2/v2/auth';

  var params = {
    client_id: '100133912723-6o35kgdq7fi6m536it9dl96o7dnim32n.apps.googleusercontent.com',
    redirect_uri: 'https://eventor.friday.tw/auth/google/callback',
    response_type: 'code',
    scope: 'profile%20email%20https://www.googleapis.com/auth/spreadsheets',
    state: redirect
  };

  var queries = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(params).map(function (key) {
    var value = params[key];
    return value ? key + '=' + value : null;
  }).filter(function (_) {
    return _;
  }).join('&');

  var url = baseURL + '?' + queries;

  return url;
}

function copy(text) {
  var textArea = document.createElement('textarea');

  //
  // *** This styling is an extra step which is likely not required. ***
  //
  // Why is it here? To ensure:
  // 1. the element is able to have focus and selection.
  // 2. if element was to flash render it has minimal visual impact.
  // 3. less flakyness with selection and copying which **might** occur if
  //    the textarea element is not visible.
  //
  // The likelihood is the element won't even render, not even a flash,
  // so some of these are just precautions. However in IE the element
  // is visible whilst the popup box asking the user for permission for
  // the web page to copy to the clipboard.
  //

  // Place in top-left corner of screen regardless of scroll position.
  textArea.style.position = 'fixed';
  textArea.style.top = 0;
  textArea.style.left = 0;

  // Ensure it has a small width and height. Setting to 1px / 1em
  // doesn't work as this gives a negative w/h on some browsers.
  textArea.style.width = '2em';
  textArea.style.height = '2em';

  // We don't need padding, reducing the size if it does flash render.
  textArea.style.padding = 0;

  // Clean up any borders.
  textArea.style.border = 'none';
  textArea.style.outline = 'none';
  textArea.style.boxShadow = 'none';

  // Avoid flash of white box if rendered for any reason.
  textArea.style.background = 'transparent';

  textArea.value = text;

  document.body.appendChild(textArea);

  textArea.select();

  var successful = void 0;
  try {
    successful = document.execCommand('copy');
  } catch (err) {
    successful = false;
  }

  document.body.removeChild(textArea);

  return successful;
}

/***/ }),

/***/ "yXRU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "z5t4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cddbb32_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_align_justify_vue__ = __webpack_require__("5F+9");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cddbb32_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_align_justify_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zGyS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_debug__ = __webpack_require__("Fy0/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_debug__);



var trace = __WEBPACK_IMPORTED_MODULE_1_debug___default()('vuex:alert');

var state = function state() {
  return {
    message: '',
    show: false,
    type: 'alert'
  };
};

var DEFAULT_ERROR_MESSAGE = '系統內部發生罷工，請聯繫系統管理員';

var ERROR_MESSAGES = {
  0: '網路連線有點問題，請稍候再試',
  401: '您可能登入憑證失效，請嘗試重新登入，若問題無法解決請聯繫系統管理員',
  403: '您可能沒有足夠的權限進行此操作，請聯繫系統管理員為您開啟權限',
  404: '我們找不到指定的資源',
  422: '您送出的資料可能不正確，請嘗試修正欄位內容的格式，例如文字長度、網址格式、Email 格式等',
  500: '艾倫寫了個 bug，你遇到了那個 bug，請聯繫系統管理員',
  504: '您送出的請求伺服器沒有回應，連線時間過久因此逾時，請聯繫系統管理員'
};

var actions = {
  set: function set(_ref, _ref2) {
    var commit = _ref.commit;
    var text = _ref2.text,
        code = _ref2.code,
        type = _ref2.type,
        error = _ref2.error;

    if (error) {
      text = error.message;
    }
    // default type is danger
    type = type || 'danger';
    var msg = text || ERROR_MESSAGES[code] || DEFAULT_ERROR_MESSAGE;
    trace('actions: setAlert', { msg: msg, type: type });
    commit('SET', { msg: msg, type: type });
  },
  remove: function remove(_ref3) {
    var commit = _ref3.commit;

    commit('REMOVE');
  },
  clear: function clear(_ref4) {
    var dispatch = _ref4.dispatch;

    return dispatch('remove');
  }
};

var mutations = {
  SET: function SET(state, _ref5) {
    var msg = _ref5.msg,
        type = _ref5.type;

    trace('mutations: SET', { msg: msg, type: type });
    state.show = true;
    state.message = msg;
    state.type = type || state.type;
  },
  REMOVE: function REMOVE(_state) {
    var init = state();
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(init).forEach(function (key) {
      _state[key] = init[key];
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state(),
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "zW1o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4810f0d2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_redo_vue__ = __webpack_require__("FOwU");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4810f0d2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_redo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zcbD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('progress-bar'),_vm._v(" "),_c('alert'),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('tooltip')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zxCS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg","fill":"#fff"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}}),_c('path',{attrs:{"d":"M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.38bc413b4af5564627c7.js